webpackJsonp([1],{

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sprite.fed911e.svg";

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_postscribe__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_postscribe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_postscribe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_header_HeaderMain__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_footer_FooterMain__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_accessory_AccessoryMain__ = __webpack_require__(650);


//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('SAVE_PEOPLE_LIST', { role: 'presidente' });
              _this.$store.dispatch('SAVE_PEOPLE_LIST', { role: 'relatore' });
              // this.$store.dispatch('SAVE_PEOPLE_LIST', { role: 'giudice' });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_postscribe___default()('#body',
    // eslint-disable-next-line no-useless-escape
    '<script src="static/bootstrap-italia/dist/js/bootstrap-italia.bundle.min.js"><\/script>');
  },

  components: {
    HeaderMain: __WEBPACK_IMPORTED_MODULE_3__components_layout_header_HeaderMain__["a" /* default */],
    FooterMain: __WEBPACK_IMPORTED_MODULE_4__components_layout_footer_FooterMain__["a" /* default */],
    AccessoryMain: __WEBPACK_IMPORTED_MODULE_5__components_layout_accessory_AccessoryMain__["a" /* default */]
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_header_HeaderTop__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_header_HeaderCenter__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_header_HeaderBottom__ = __webpack_require__(637);
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderMain',
  mounted: function mounted() {},
  data: function data() {
    return {
      scrollContainerClass: {
        'progress-bar-container--container': false,
        'scrool-progress-bar': true,
        'sticky-top': true
      },
      scrollBarClass: {
        'primary-bg': true
      }
    };
  },

  components: {
    HeaderTop: __WEBPACK_IMPORTED_MODULE_0__components_layout_header_HeaderTop__["a" /* default */],
    HeaderCenter: __WEBPACK_IMPORTED_MODULE_1__components_layout_header_HeaderCenter__["a" /* default */],
    HeaderBottom: __WEBPACK_IMPORTED_MODULE_2__components_layout_header_HeaderBottom__["a" /* default */]
  }
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderMain',
  data: function data() {
    return {
      icons: {
        itExpand: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-expand',
        itUser: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-user'
      }
    };
  },

  components: {}
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderCenter',
  data: function data() {
    return {
      icons: {
        itExpand: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-expand',
        itDesignersItalia: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-designers-italia',
        itFacebook: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-facebook',
        itTwitter: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-twitter',
        itGithub: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-github',
        itSearch: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-search',
        itBurger: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-burger'
      }
    };
  },

  components: {}
});

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderBottom',
  data: function data() {
    return {
      icons: {
        itSearch: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-search',
        itBurger: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-burger'
      },
      activePage: {
        home: false,
        pronunce: false,
        informazioni: false,
        sviluppatori: false
      }
    };
  },
  mounted: function mounted() {
    var currentRouteName = this.$router.currentRoute.name;
    this.activePage[currentRouteName] = true;
  },

  watch: {
    // eslint-disable-next-line object-shorthand
    '$route': function $route(to, from) {
      this.activePage[to.name] = true;
      this.activePage[from.name] = false;
    }
  },
  methods: {},
  components: {}
});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_footer_FooterTop__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_footer_FooterBottom__ = __webpack_require__(646);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FooterMain',
  data: function data() {
    return {
      icons: {
        itDesignersItalia: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-designers-italia'
      }
    };
  },

  components: {
    FooterTop: __WEBPACK_IMPORTED_MODULE_1__components_layout_footer_FooterTop__["a" /* default */],
    FooterBottom: __WEBPACK_IMPORTED_MODULE_2__components_layout_footer_FooterBottom__["a" /* default */]
  }
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FooterTop',
  data: function data() {
    return {
      icons: {
        itDesignersItalia: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-designers-italia',
        itTwitter: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-twitter',
        itMedium: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-medium',
        itGithub: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-github',
        itMail: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-mail',
        itBurger: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-burger'
      }
    };
  },

  components: {}
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FooterBottom',
  data: function data() {
    return {
      icons: {
        itDesignersItalia: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-designers-italia'
      }
    };
  },

  components: {}
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_accessory_BackToTopButton__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_accessory_ModalSearch__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_accessory_BreadCrumbs__ = __webpack_require__(665);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccessoryMain',
  data: function data() {
    return {};
  },

  components: {
    BackToTopButton: __WEBPACK_IMPORTED_MODULE_0__components_layout_accessory_BackToTopButton__["a" /* default */],
    ModalSearch: __WEBPACK_IMPORTED_MODULE_1__components_layout_accessory_ModalSearch__["a" /* default */],
    BreadCrumbs: __WEBPACK_IMPORTED_MODULE_2__components_layout_accessory_BreadCrumbs__["a" /* default */]
  }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-search',
  components: {},
  data: function data() {
    return {
      icons: {
        itArrowUp: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-arrow-up'
      }
    };
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_accessory_SearchForm__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-search',
  components: {
    SearchForm: __WEBPACK_IMPORTED_MODULE_0__components_layout_accessory_SearchForm__["a" /* default */]
  },
  methods: {
    deleteFilters: function deleteFilters() {
      var _this = this;

      this.$refs.searchForm.filters.years = [];
      this.$refs.searchForm.filters.presidents = [];
      this.$refs.searchForm.filters.relators = [];
      this.$refs.searchForm.$refs.yearsRange.setValue(['1956', '2019']);
      this.$store.dispatch('EMPTY_PRONUNCE_FILTER').then(function () {
        _this.$store.dispatch('EMPTY_DOCUMENTS_LIST').then(function () {
          _this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: _this.documentsSetsStartFromDocumentSentenze,
            size: _this.documentsSetsSize,
            type: 'sentenza'
          });
          _this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: _this.documentsSetsStartFromDocumentOrdinanze,
            size: _this.documentsSetsSize,
            type: 'ordinanza'
          });
        });
      });
    },
    filterPronunce: function filterPronunce() {
      var _this2 = this;

      var searchFormFilters = this.$refs.searchForm.filters;
      if (searchFormFilters.years.length || searchFormFilters.numbers.length || searchFormFilters.ecli.length || searchFormFilters.presidents.length || searchFormFilters.relators.length || searchFormFilters.judges.length) {
        this.$store.dispatch('EMPTY_PRONUNCE_FILTER').then(function () {
          _this2.$store.dispatch('SAVE_PRONUNCE_FILTER', {
            filters: {
              years: searchFormFilters.years,
              presidents: searchFormFilters.presidents,
              relators: searchFormFilters.relators
              // judges: searchFormFilters.judges,
            }
          }).then(function () {
            _this2.$store.dispatch('EMPTY_DOCUMENTS_LIST').then(function () {
              _this2.$store.dispatch('SAVE_DOCUMENTS_LIST', {
                start: _this2.documentsSetsStartFromDocumentSentenze,
                size: _this2.documentsSetsSize,
                type: 'sentenza'
              });
              _this2.$store.dispatch('SAVE_DOCUMENTS_LIST', {
                start: _this2.documentsSetsStartFromDocumentOrdinanze,
                size: _this2.documentsSetsSize,
                type: 'ordinanza'
              });
              _this2.$router.push({ path: '/pronunce' });
            });
          });
        });
      }
    }
  },
  data: function data() {
    return {
      icons: {
        itClose: __WEBPACK_IMPORTED_MODULE_1_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-close'
      }
    };
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_accessory_Spinner__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_italia_dist_svg_sprite_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_vue_slider_component_theme_bootstrap_italia_css__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_vue_slider_component_theme_bootstrap_italia_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_vue_slider_component_theme_bootstrap_italia_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








function isDescendant(parent, child) {
  var node = child.parentNode;
  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'search-form',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_layout_accessory_Spinner__["a" /* default */],
    VueSlider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
  },
  mounted: function mounted() {},
  updated: function updated() {
    // eslint-disable-next-line no-undef
    /* $('.it-date-datepicker').datepicker({
      inputFormat: ['yyyy'],
      outputFormat: 'yyyy',
      viewMode: 'years',
      minViewMode: 'years',
      // isDateDisabled: true,
      // isMonthDisabled: true,
    }); */
    if (this.presidenti) {
      // eslint-disable-next-line no-undef
      $(this.$refs.autocompletePresidente).autocomplete();
    }
    if (this.relatori) {
      // eslint-disable-next-line no-undef
      $(this.$refs.autocompleteRelatore).autocomplete();
    }
    if (this.giudici) {
      // eslint-disable-next-line no-undef
      $(this.$refs.autocompleteGiudice).autocomplete();
    }
  },

  methods: {
    deleteFilter: function deleteFilter(type, index) {
      this.filters[type].splice(index, 1);
    },
    autocompleteClicked: function autocompleteClicked(el) {
      el.preventDefault();
      if (el.target.closest('ul.autocomplete-list-show')) {
        if (isDescendant(document.getElementById('autocomplete-presidente-form-group'), el.target)) {
          this.filters.presidents.push(decodeURI(el.target.closest('a').href.split('#')[1]));
        }
        if (isDescendant(document.getElementById('autocomplete-relatori-form-group'), el.target)) {
          this.filters.relators.push(decodeURI(el.target.closest('a').href.split('#')[1]));
        }
        if (isDescendant(document.getElementById('autocomplete-giudici-form-group'), el.target)) {
          this.filters.judges.push(decodeURI(el.target.closest('a').href.split('#')[1]));
        }
        // eslint-disable-next-line no-undef
        $('.autocomplete-list').removeClass('autocomplete-list-show');
        // eslint-disable-next-line no-undef
        $('.autocomplete').val('');
      }
    },
    selectYears: function selectYears() {
      this.filters.years = [];
      var yearsRange = this.$refs.yearsRange.getValue();
      var endYear = yearsRange[1];
      var startYear = yearsRange[0];
      while (startYear <= endYear) {
        this.filters.years.push(startYear);
        startYear += 1;
      }
    }
  },
  // $('.autocomplete').autocomplete();
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['presidenti', 'relatori', 'giudici']),
  data: function data() {
    return {
      minYear: 1956,
      maxYear: 2019,
      defaultYearsRange: [1956, 2019],
      marks: {
        1956: '1956',
        2019: '2019'
      },
      icons: {
        itFile: __WEBPACK_IMPORTED_MODULE_3_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-file',
        itUser: __WEBPACK_IMPORTED_MODULE_3_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-user',
        itExpand: __WEBPACK_IMPORTED_MODULE_3_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-expand',
        itSearch: __WEBPACK_IMPORTED_MODULE_3_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-search',
        itClose: __WEBPACK_IMPORTED_MODULE_3_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-close'
      },
      filters: {
        years: [],
        numbers: [],
        ecli: [],
        presidents: [],
        relators: [],
        judges: []
      }
    };
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spinner-row',
  components: {},
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bread-crumbs',
  components: {},
  mounted: function mounted() {
    var currentRouteName = this.$router.currentRoute.name;
    this.activePage = currentRouteName;
  },

  watch: {
    // eslint-disable-next-line object-shorthand
    '$route': function $route(to) {
      this.activePage = to.name;
    }
  },

  data: function data() {
    return {
      icons: {
        itArrowUp: __WEBPACK_IMPORTED_MODULE_0_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-arrow-up'
      },
      activePage: 'home'
    };
  }
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_imports_YearCards__ = __webpack_require__(674);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    YearCards: __WEBPACK_IMPORTED_MODULE_2__components_imports_YearCards__["a" /* default */]
  },
  breadcrumb: {
    label: 'Home'
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', 'hi!');

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {},
  methods: {},
  data: function data() {
    return {
      site: {
        baseurl: 'pippobaudo'
      }
    };
  }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'YearCards',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var docsPerYearJson, docsPerYear;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.docPerYear) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$proxy + 'countDocs.xq');

            case 3:
              docsPerYearJson = _context.sent;
              docsPerYear = docsPerYearJson.data.entries;

              _this.docPerYear = docsPerYear;

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    /* this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'ADD_YEAR') {
        this.latestPronunciaPerYear = state;
      }
    }); */
  },

  methods: {
    goToPronunce: function goToPronunce(e, year) {
      var _this2 = this;

      e.preventDefault();
      this.$store.dispatch('EMPTY_PRONUNCE_FILTER').then(function () {
        _this2.$store.dispatch('SAVE_PRONUNCE_FILTER', {
          type: 'years',
          filters: {
            years: [year]
          }
        }).then(function () {
          _this2.$store.dispatch('EMPTY_DOCUMENTS_LIST').then(function () {
            _this2.$router.push({ path: '/pronunce' });
          });
        });
      });
    },
    getGitHubLink: function getGitHubLink(year) {
      return 'https://gitlab.com/CIRSFID/cortecostituzionale-py/tree/master/data/out/valid/' + year;
    },
    getLatestYear: function getLatestYear() {
      var years = this.docPerYear;
      return years;
    },
    test: function test(years, yearToSearch) {
      var myYear = __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.where(years, { year: yearToSearch });
      return myYear;
    },
    getLatestSentenza: function getLatestSentenza(years, yearToSearch) {
      var myYear = __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.where(years, { year: yearToSearch })[0];
      var latestSentenza = false;
      if (myYear) {
        var latest = myYear.entries.latestSentenza.pronunciaInfo;
        latestSentenza = latest;
      }
      return latestSentenza;
    },
    getLatestOrdinanza: function getLatestOrdinanza(years, yearToSearch) {
      var myYear = __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.where(years, { year: yearToSearch })[0];
      var latestOrdinanza = false;
      if (myYear) {
        var latest = myYear.entries.latestOrdinanza.pronunciaInfo;
        latestOrdinanza = latest;
      }
      return latestOrdinanza;
    }
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['latestPerYear']),
  data: function data() {
    return {
      docPerYear: null,
      // latestPronunciaPerYear: [],
      icons: {
        itCalendar: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-calendar',
        itInfoCircle: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-info-circle',
        itArrowRight: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-arrow-right',
        itGitHub: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-github'
      }
    };
  }
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_Document__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_imports_DocumentsList__ = __webpack_require__(866);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pronunce',
  components: {
    Document: __WEBPACK_IMPORTED_MODULE_0__components_pages_Document__["a" /* default */],
    DocumentsList: __WEBPACK_IMPORTED_MODULE_1__components_imports_DocumentsList__["a" /* default */]
  },
  breadcrumb: {
    label: 'Pronunce',
    parent: 'home'
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Document_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b2640d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Document_vue__ = __webpack_require__(865);
function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64b2640d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Document_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b2640d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Document_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_akomando_tree__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scrollto__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_imports_AknVisualizer__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layout_header_HeaderDocument__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_accessory_ModalDocumentInfo__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layout_accessory_Spinner__ = __webpack_require__(81);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'document',
  components: {
    AknVisualizer: __WEBPACK_IMPORTED_MODULE_6__components_imports_AknVisualizer__["a" /* default */],
    HeaderDocument: __WEBPACK_IMPORTED_MODULE_7__components_layout_header_HeaderDocument__["a" /* default */],
    ModalDocumentInfo: __WEBPACK_IMPORTED_MODULE_8__components_layout_accessory_ModalDocumentInfo__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_9__components_layout_accessory_Spinner__["a" /* default */]
  },
  breadcrumb: {
    label: 'Document'
  },
  props: ['docUri'],
  watch: {
    // eslint-disable-next-line object-shorthand
    '$route': function $route(to) {
      this.getDocument(to);
    }
  },
  mounted: function mounted() {
    // const testXML = await Vue.axios.get('static/akn-docs/CorteCostituzionale
    // _1956_2018/2018/sentenza/akn_it_judgment_sentenza_cost_2018_141/
    // akn_it_judgment_sentenza_cost_2018_141_ita@_!main.xml');
    this.getDocument();
  },

  computed: {
    getAknString: function getAknString() {
      return this.aknString;
    }
  },
  methods: {
    getDocument: function getDocument() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var separator, url, document, aknXml;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.aknString = null;
                separator =  false ? '?' : '&';
                url = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$proxy + 'getDocument.xq' + separator + 'uri=' + _this.docUri + '&year=' + _this.$route.params.year + '&number=' + _this.$route.params.number;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get(url);

              case 5:
                document = _context.sent;
                aknXml = document.data;

                _this.aknString = aknXml;
                __WEBPACK_IMPORTED_MODULE_3_akomando_tree__["a" /* default */].locale = 'it_it_judgment_corte_costituzionale';
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_3_akomando_tree__["a" /* default */].getIndex({
                  aknString: aknXml
                });

              case 11:
                _this.aknIndex = _context.sent;

                _this.windowHeight = window.innerHeight;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goToPartition: function goToPartition(partition) {
      var foundPartition = this.$refs.aknVisualizer.findElements(partition.xpath);
      __WEBPACK_IMPORTED_MODULE_4_vue_scrollto___default.a.scrollTo(foundPartition[0], 500, {
        offset: -50
      });
    },
    getIndexHeight: function getIndexHeight() {
      return 'height: ' + this.windowHeight + 'px';
    },
    getHierChildrens: function getHierChildrens(item, hierarchies) {
      var itemXPath = item.xpath;
      var children = [];
      hierarchies.forEach(function (anItem) {
        if (anItem.xpath.startsWith(itemXPath) && anItem.xpath !== itemXPath) {
          children.push(anItem);
        }
      });
      return children;
    }
  },
  data: function data() {
    return {
      aknIndex: null,
      aknString: null,
      windowHeight: null,
      icons: {
        itExpand: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-expand'
      }
    };
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_akomando__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_akomando___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_akomando__);

//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-param-reassign */
/* eslint-disable max-len */

// import Vue from 'vue';


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AknVisualizer',
  props: ['theme', 'aknString'],
  beforeMount: function beforeMount() {
    // create the akomando object
    var akomando = Object(__WEBPACK_IMPORTED_MODULE_1_akomando__["createAkomando"])({
      aknString: this.aknString
    });
    this.akomando = akomando;

    // create the HTML dom
    var aknDom = this.akomando.getAkomaNtoso({
      serialize: 'HTMLString',
      addHtmlElement: false,
      addHeadElement: false,
      addBodyElement: false,
      addDataXPath: true,
      newLines: true
    });
    this.aknDOM = aknDom.replace(/\s+/g, ' ');
    var aknMeta = this.akomando.getMeta({
      serialize: 'JSON',
      metaRoot: 'FRBRManifestation'
    });
    this.aknMeta = aknMeta;
  },
  mounted: function mounted() {
    var _this = this;

    this.$refs.aknDom.querySelectorAll('div.akn-ref').forEach(function (el) {
      if (el.dataset.aknHref.includes('sentenza/corteCostituzionale') || el.dataset.aknHref.includes('ordinanza/corteCostituzionale')) {
        var docUri = el.dataset.aknHref;
        var year = docUri.split('/')[6];
        var number = docUri.split('/')[7];
        if (el.dataset.aknHref.includes('sentenza')) {
          el.classList.add('sentenze-link');
          el.setAttribute('title', 'Anteprima Sentenza n# ' + number + ' del ' + year + ' - (Clicca sul Link per Visualizzare la Sentenza completa)');
          el.dataset.container = 'body';
          el.dataset.toggle = 'popover';
          el.dataset.trigger = 'hover';
          el.dataset.html = 'true';
          el.dataset.content = _this.getLoader();
          el.addEventListener('click', function () {
            _this.$router.push({
              path: '/pronuncia/sentenza/' + year + '/' + number
              // query: { docUri },
            });
          });
          /* el.addEventListener('mouseover', () => {
            this.setPopoverContent(number, year, docUri, el);
          }); */
        } else {
          el.classList.add('ordinanze-link');
          el.addEventListener('click', function () {
            _this.$router.push({
              path: '/pronuncia/ordinanza/' + year + '/' + number
              // query: { docUri },
            });
          });
        }
      } else {
        var _docUri = el.dataset.aknHref;
        var _year = _docUri.split('/')[6];
        var normalizedYear = _year.length === 4 ? _year : _year.split('-')[0];
        var _number = _docUri.split('/')[7];
        var article = _docUri.includes('#') ? _docUri.split('#')[1] : '';
        var normalizedArticle = article === '' ? '' : '~art' + article.split('_')[1];
        var date = _this.aknMeta[0].FRBRManifestation.FRBRdate[0].$.date;
        var urn = _docUri.includes('cost') ? 'urn:nir:stato:costituzione!vig=' + date + normalizedArticle : 'urn:nir:stato:legge:' + normalizedYear + ';' + _number + '!vig=' + date + normalizedArticle;
        var link = 'https://www.normattiva.it/uri-res/N2Ls?' + urn;
        el.classList.add('legge-link');
        el.addEventListener('click', function () {
          window.open(link, '_blank');
        });
      }
    });
    // eslint-disable-next-line no-undef
    // $('.sentenze-link').popover();
  },

  methods: {
    findElements: function findElements(identifier) {
      var elements = [];
      this.$el.querySelectorAll('*').forEach(function (el) {
        var identifiers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(el.dataset);
        if (identifiers.includes(identifier)) {
          elements.push(el);
        }
      });
      return elements;
    },
    getLoader: function getLoader() {
      return '\n        <div class="progress-spinner progress-spinner-active mx-auto text-center">\n        <span class="sr-only">Caricamento...</span>\n        </div>\n      ';
    }
  },
  data: function data() {
    return {
      aknDOM: null,
      akomando: null,
      popovers: []
    };
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__guillaumebriday_vue_scroll_progress_bar__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderDocument',
  props: ['docUri', 'year', 'number'],
  methods: {
    getDownloadUrl: function getDownloadUrl(docUri) {
      var separator =  false ? '?' : '&';
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$proxy + 'getDocument.xq' + separator + 'uri=' + docUri + '&year=' + this.year + '&number=' + this.number;
    }
  },
  data: function data() {
    return {
      icons: {
        itArrowDownTriangle: __WEBPACK_IMPORTED_MODULE_2_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-arrow-down-triangle',
        itCodeCircle: __WEBPACK_IMPORTED_MODULE_2_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-code-circle',
        itSearch: __WEBPACK_IMPORTED_MODULE_2_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-search',
        itInfoCircle: __WEBPACK_IMPORTED_MODULE_2_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-info-circle',
        itMoreItems: __WEBPACK_IMPORTED_MODULE_2_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-more-items'
      },
      scrollContainerClass: {
        'progress-bar-container--container': false,
        'scrool-progress-bar': true
      },
      scrollBarClass: {
        'primary-bg': true
      }

    };
  },

  components: {
    VueScrollProgressBar: __WEBPACK_IMPORTED_MODULE_1__guillaumebriday_vue_scroll_progress_bar__["a" /* default */]
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VueScrollProgressBar",

  props: {
    height: {
      type: String,
      default: ".5rem"
    },

    zIndex: {
      type: String,
      default: "50"
    },

    backgroundColor: {
      type: String,
      default: "linear-gradient(to right, #38C172, #51D88A)"
    },

    containerColor: {
      type: String,
      default: "transparent"
    },

    barClass: {
      type: Object,
      default: function _default() {}
    },

    containerClass: {
      type: Object,
      default: function _default() {
        return {
          'progress-bar-container--container': true
        };
      }
    }
  },

  data: function data() {
    return {
      width: 0
    };
  },


  methods: {
    handleScroll: function handleScroll() {
      var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      this.width = window.scrollY / height * 100;
      var eventWidth = Math.ceil(this.width);

      if (eventWidth === 0) {
        this.$emit("begin");
      }

      if (eventWidth === 100) {
        this.$emit("complete");
      }
    }
  },

  mounted: function mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.dispatchEvent(new Event("scroll"));
  },
  destroyed: function destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_accessory_Spinner__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_accessory_ChartLegislazione__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_accessory_ChartGiurisprudenza__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_italia_dist_svg_sprite_svg__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-document-info',
  props: ['aknString', 'year', 'number'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_layout_accessory_Spinner__["a" /* default */],
    ChartLegislazione: __WEBPACK_IMPORTED_MODULE_4__components_layout_accessory_ChartLegislazione__["a" /* default */],
    ChartGiurisprudenza: __WEBPACK_IMPORTED_MODULE_5__components_layout_accessory_ChartGiurisprudenza__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var separator, url, documentInfo;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              separator =  false ? '?' : '&';
              url = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$proxy + 'getDocumentInfo.xq' + separator + 'uri=' + _this.docUri + '&year=' + _this.year + '&number=' + _this.number;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get(url);

            case 4:
              documentInfo = _context.sent;

              _this.documentInfo = documentInfo.data;

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {},
  data: function data() {
    return {
      documentInfo: null,
      icons: {
        itClose: __WEBPACK_IMPORTED_MODULE_6_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-close'
      },
      chartData: null,
      sunburst: null
    };
  }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_akomando__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_akomando___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_akomando__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_string__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_echarts__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_sunburst__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_sunburst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_sunburst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_polar__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_polar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_polar__);


//
//
//
//

/* eslint-disable prefer-rest-params */










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-legislazione',
  props: ['aknString'],
  components: {
    'v-chart': __WEBPACK_IMPORTED_MODULE_6_vue_echarts__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    var _this = this;

    // create the akomando object
    var akomando = Object(__WEBPACK_IMPORTED_MODULE_2_akomando__["createAkomando"])({
      aknString: this.aknString
    });
    this.akomando = akomando;

    // create the HTML dom
    var aknDom = this.akomando.getAkomaNtoso({});
    var refs = aknDom.getElementsByTagName('ref');

    // extract the meta
    var aknMeta = this.akomando.getMeta({
      serialize: 'JSON',
      metaRoot: 'FRBRManifestation'
    });
    this.aknMeta = aknMeta;

    var refsInfo = [];

    var _loop = function _loop(i) {
      var href = refs[i].getAttribute('href');
      // handle click
      var docUri = href;
      var year = docUri.split('/')[6];
      var normalizedYear = year.length === 4 ? year : year.split('-')[0];
      var number = docUri.split('/')[7];
      var article = docUri.includes('#') ? docUri.split('#')[1] : '';
      var normalizedArticle = article === '' ? '' : '~art' + article.split('_')[1];
      var date = _this.aknMeta[0].FRBRManifestation.FRBRdate[0].$.date;
      var urn = docUri.includes('cost') ? 'urn:nir:stato:costituzione!vig=' + date + normalizedArticle : 'urn:nir:stato:legge:' + normalizedYear + ';' + number + '!vig=' + date + normalizedArticle;
      var link = 'https://www.normattiva.it/uri-res/N2Ls?' + urn;
      var docType = __WEBPACK_IMPORTED_MODULE_4_string___default()(href.split('/')[4]).humanize().s;
      if (docType !== 'Sentenza' && docType !== 'Ordinanza') {
        docType = docType.split(' ').join('\n');
        var docTypeInResult = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(refsInfo, { name: docType });
        if (!docTypeInResult) {
          refsInfo.push({
            name: docType,
            orderValue: href.split('/')[4],
            children: []
          });
        }
        docTypeInResult = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(refsInfo, { name: docType });

        var docName = function () {
          if (docType.toLowerCase() !== 'costituzione') {
            return 'n\xB0 ' + href.split('/')[7] + ' \n del ' + href.split('/')[6];
          } else if (href.includes('#')) {
            return __WEBPACK_IMPORTED_MODULE_4_string___default()(href.split('#')[1]).humanize().s;
          }
          return '';
        }();
        if (docName !== '' && !__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(docTypeInResult.children, { name: docName })) {
          docTypeInResult.children.push({
            name: docName,
            orderValue: docType.toLowerCase() !== 'costituzione' ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(href.split('/')[6]).unix() : Number(href.split('#')[1].split('_')[1]),
            value: 1,
            link: link
          });
        }
      }
    };

    for (var i = 0; i < refs.length; i += 1) {
      _loop(i);
    }
    var orderedRefs = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.chain(refsInfo).orderBy(['orderValue'], ['asc']).value();
    orderedRefs.map(function (o) {
      // eslint-disable-next-line no-param-reassign
      o.children = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(o.children, ['orderValue'], ['asc']);
      return o;
    });

    this.sunburst = {
      title: {
        text: 'Grafico dei riferimenti',
        textStyle: {
          fontSize: 14,
          align: 'center'
        },
        subtextStyle: {
          align: 'center'
        }
      },
      series: {
        type: 'sunburst',
        highlightPolicy: 'ancestor',
        data: orderedRefs,
        radius: [0, '95%'],
        sort: null,
        levels: [{
          r0: '15%',
          r: '35%',
          itemStyle: {
            borderWidth: 2
          },
          label: {
            rotate: 'tangential'
          }
        }, {
          r0: '35%',
          r: '70%',
          label: {
            align: 'right'
          }
        }, {
          r0: '70%',
          r: '72%',
          label: {
            position: 'outside',
            silent: false
          },
          itemStyle: {
            borderWidth: 3
          }
        }]
      }
    };
  },
  mounted: function mounted() {
    /* const separator = (process.env.NODE_ENV === 'development') ? '?' : '&';
    const url = `${Vue.prototype.$proxy}getDocumentInfo.xq${separator}
    uri=${this.docUri}&year=${this.year}&number=${this.number}`;
    const documentInfo = await Vue.axios.get(url);
    this.documentInfo = documentInfo.data; */

    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: {
    onClick: function onClick() {
      if (arguments[0].data.link) {
        window.open(arguments[0].data.link, '_blank');
      }
    }
  },
  data: function data() {
    return {
      documentInfo: null,
      sunburst: null
    };
  }
});

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ECharts_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3f9022a5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ECharts_vue__ = __webpack_require__(814);
function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ECharts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3f9022a5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ECharts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_resize_detector__ = __webpack_require__(813);


//
//
//
//
//
//
//
//
//
//
//





// enumerating ECharts events for now
var EVENTS = ['legendselectchanged', 'legendselected', 'legendunselected', 'legendscroll', 'datazoom', 'datarangeselected', 'timelinechanged', 'timelineplaychanged', 'restore', 'dataviewchanged', 'magictypechanged', 'geoselectchanged', 'geoselected', 'geounselected', 'pieselectchanged', 'pieselected', 'pieunselected', 'mapselectchanged', 'mapselected', 'mapunselected', 'axisareaselected', 'focusnodeadjacency', 'unfocusnodeadjacency', 'brush', 'brushselected', 'rendered', 'finished', 'click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];

var INIT_TRIGGERS = ['theme', 'initOptions', 'autoresize'];
var REWATCH_TRIGGERS = ['manualUpdate', 'watchShallow'];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    options: Object,
    theme: [String, Object],
    initOptions: Object,
    group: String,
    autoresize: Boolean,
    watchShallow: Boolean,
    manualUpdate: Boolean
  },
  data: function data() {
    return {
      lastArea: 0
    };
  },

  watch: {
    group: function group(_group) {
      this.chart.group = _group;
    }
  },
  methods: {
    // provide a explicit merge option method
    mergeOptions: function mergeOptions(options, notMerge, lazyUpdate) {
      if (this.manualUpdate) {
        this.manualOptions = options;
      }

      if (!this.chart) {
        this.init();
      } else {
        this.delegateMethod('setOption', options, notMerge, lazyUpdate);
      }
    },

    // just delegates ECharts methods to Vue component
    // use explicit params to reduce transpiled size for now
    appendData: function appendData(params) {
      this.delegateMethod('appendData', params);
    },
    resize: function resize(options) {
      this.delegateMethod('resize', options);
    },
    dispatchAction: function dispatchAction(payload) {
      this.delegateMethod('dispatchAction', payload);
    },
    convertToPixel: function convertToPixel(finder, value) {
      return this.delegateMethod('convertToPixel', finder, value);
    },
    convertFromPixel: function convertFromPixel(finder, value) {
      return this.delegateMethod('convertFromPixel', finder, value);
    },
    containPixel: function containPixel(finder, value) {
      return this.delegateMethod('containPixel', finder, value);
    },
    showLoading: function showLoading(type, options) {
      this.delegateMethod('showLoading', type, options);
    },
    hideLoading: function hideLoading() {
      this.delegateMethod('hideLoading');
    },
    getDataURL: function getDataURL(options) {
      return this.delegateMethod('getDataURL', options);
    },
    getConnectedDataURL: function getConnectedDataURL(options) {
      return this.delegateMethod('getConnectedDataURL', options);
    },
    clear: function clear() {
      this.delegateMethod('clear');
    },
    dispose: function dispose() {
      this.delegateMethod('dispose');
    },
    delegateMethod: function delegateMethod(name) {
      var _chart;

      if (!this.chart) {
        this.init();
      }

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_chart = this.chart)[name].apply(_chart, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(args));
    },
    delegateGet: function delegateGet(methodName) {
      if (!this.chart) {
        this.init();
      }
      return this.chart[methodName]();
    },
    getArea: function getArea() {
      return this.$el.offsetWidth * this.$el.offsetHeight;
    },
    init: function init() {
      var _this = this;

      if (this.chart) {
        return;
      }

      var chart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(this.$el, this.theme, this.initOptions);

      if (this.group) {
        chart.group = this.group;
      }

      chart.setOption(this.manualOptions || this.options || {}, true);

      // expose ECharts events as custom events
      EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);
        });
      });

      if (this.autoresize) {
        this.lastArea = this.getArea();
        this.__resizeHandler = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
          if (_this.lastArea === 0) {
            // emulate initial render for initially hidden charts
            _this.mergeOptions({}, true);
            _this.resize();
            _this.mergeOptions(_this.options || _this.manualOptions || {}, true);
          } else {
            _this.resize();
          }
          _this.lastArea = _this.getArea();
        }, 100, { leading: true });
        Object(__WEBPACK_IMPORTED_MODULE_4_resize_detector__["a" /* addListener */])(this.$el, this.__resizeHandler);
      }

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(this, {
        // Only recalculated when accessed from JavaScript.
        // Won't update DOM on value change because getters
        // don't depend on reactive values
        width: {
          configurable: true,
          get: function get() {
            return _this.delegateGet('getWidth');
          }
        },
        height: {
          configurable: true,
          get: function get() {
            return _this.delegateGet('getHeight');
          }
        },
        isDisposed: {
          configurable: true,
          get: function get() {
            return !!_this.delegateGet('isDisposed');
          }
        },
        computedOptions: {
          configurable: true,
          get: function get() {
            return _this.delegateGet('getOption');
          }
        }
      });

      this.chart = chart;
    },
    initOptionsWatcher: function initOptionsWatcher() {
      var _this2 = this;

      if (this.__unwatchOptions) {
        this.__unwatchOptions();
        this.__unwatchOptions = null;
      }

      if (!this.manualUpdate) {
        this.__unwatchOptions = this.$watch('options', function (val, oldVal) {
          if (!_this2.chart && val) {
            _this2.init();
          } else {
            // mutating `options` will lead to merging
            // replacing it with new reference will lead to not merging
            // eg.
            // `this.options = Object.assign({}, this.options, { ... })`
            // will trigger `this.chart.setOption(val, true)
            // `this.options.title.text = 'Trends'`
            // will trigger `this.chart.setOption(val, false)`
            _this2.chart.setOption(val, val !== oldVal);
          }
        }, { deep: !this.watchShallow });
      }
    },
    destroy: function destroy() {
      if (this.autoresize) {
        Object(__WEBPACK_IMPORTED_MODULE_4_resize_detector__["b" /* removeListener */])(this.$el, this.__resizeHandler);
      }
      this.dispose();
      this.chart = null;
    },
    refresh: function refresh() {
      if (this.chart) {
        this.destroy();
        this.init();
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.initOptionsWatcher();

    INIT_TRIGGERS.forEach(function (prop) {
      _this3.$watch(prop, function () {
        _this3.refresh();
      }, { deep: true });
    });

    REWATCH_TRIGGERS.forEach(function (prop) {
      _this3.$watch(prop, function () {
        _this3.initOptionsWatcher();
        _this3.refresh();
      });
    });
  },
  mounted: function mounted() {
    // auto init if `options` is already provided
    if (this.options) {
      this.init();
    }
  },
  activated: function activated() {
    if (this.autoresize) {
      this.chart && this.chart.resize();
    }
  },
  destroyed: function destroyed() {
    if (this.chart) {
      this.destroy();
    }
  },
  connect: function connect(group) {
    if (typeof group !== 'string') {
      group = group.map(function (chart) {
        return chart.chart;
      });
    }
    __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.connect(group);
  },
  disconnect: function disconnect(group) {
    __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.disConnect(group);
  },
  registerMap: function registerMap(mapName, geoJSON, specialAreas) {
    __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.registerMap(mapName, geoJSON, specialAreas);
  },
  registerTheme: function registerTheme(name, theme) {
    __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.registerTheme(name, theme);
  },

  graphic: __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.graphic
});

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_akomando__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_akomando___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_akomando__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_string__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_echarts__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_sunburst__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_sunburst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_sunburst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_polar__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_polar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_polar__);


//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  /* eslint-disable prefer-rest-params */

  name: 'chart-giurisprudenza',
  props: ['aknString'],
  components: {
    'v-chart': __WEBPACK_IMPORTED_MODULE_6_vue_echarts__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    // create the akomando object
    var akomando = Object(__WEBPACK_IMPORTED_MODULE_2_akomando__["createAkomando"])({
      aknString: this.aknString
    });
    this.akomando = akomando;

    // create the HTML dom
    var aknDom = this.akomando.getAkomaNtoso({});
    var refs = aknDom.getElementsByTagName('ref');
    var refsInfo = [];

    var _loop = function _loop(i) {
      var href = refs[i].getAttribute('href');
      var docType = __WEBPACK_IMPORTED_MODULE_4_string___default()(href.split('/')[4]).humanize().s;
      if (docType === 'Sentenza' || docType === 'Ordinanza') {
        docType = docType.split(' ').join('\n');
        var docTypeInResult = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(refsInfo, { name: docType });
        if (!docTypeInResult) {
          refsInfo.push({
            name: docType,
            orderValue: href.split('/')[4],
            itemStyle: {
              color: docType === 'Sentenza' ? '#133A3A' : '#638490'
            },
            children: []
          });
        }
        docTypeInResult = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(refsInfo, { name: docType });

        var docYear = function () {
          var docDate = href.split('/')[6];
          if (docDate.includes('-')) {
            return docDate.split('-')[0];
          }
          return docDate;
        }();
        var docNumber = href.split('/')[7];

        var docName = function () {
          if (docType.toLowerCase() !== 'costituzione') {
            return 'n\xB0 ' + href.split('/')[7] + ' \n del ' + href.split('/')[6];
          } else if (href.includes('#')) {
            return __WEBPACK_IMPORTED_MODULE_4_string___default()(href.split('#')[1]).humanize().s;
          }
          return '';
        }();
        if (docName !== '' && !__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(docTypeInResult.children, { name: docName })) {
          docTypeInResult.children.push({
            name: docName,
            orderValue: docType.toLowerCase() !== 'costituzione' ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(href.split('/')[6]).unix() : Number(href.split('#')[1].split('_')[1]),
            itemStyle: {
              color: docType === 'Sentenza' ? '#133A3A' : '#638490'
            },
            docType: href.split('/')[4],
            docYear: docYear,
            docNumber: docNumber,
            value: 1
          });
        }
      }
    };

    for (var i = 0; i < refs.length; i += 1) {
      _loop(i);
    }
    var orderedRefs = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.chain(refsInfo).orderBy(['orderValue'], ['asc']).value();
    orderedRefs.map(function (o) {
      // eslint-disable-next-line no-param-reassign
      o.children = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(o.children, ['orderValue'], ['asc']);
      return o;
    });

    this.sunburst = {
      title: {
        text: 'Grafico dei riferimenti',
        textStyle: {
          fontSize: 14,
          align: 'center'
        },
        subtextStyle: {
          align: 'center'
        }
      },
      series: {
        type: 'sunburst',
        highlightPolicy: 'ancestor',
        data: orderedRefs,
        radius: [0, '95%'],
        sort: null,
        levels: [{
          r0: '15%',
          r: '35%',
          itemStyle: {
            borderWidth: 2
          },
          label: {
            rotate: 'tangential'
          }
        }, {
          r0: '35%',
          r: '70%',
          label: {
            align: 'right'
          }
        }, {
          r0: '70%',
          r: '72%',
          label: {
            position: 'outside',
            silent: false
          },
          itemStyle: {
            borderWidth: 3
          }
        }]
      }
    };
  },
  mounted: function mounted() {
    /* const separator = (process.env.NODE_ENV === 'development') ? '?' : '&';
    const url = `${Vue.prototype.$proxy}getDocumentInfo.xq${separator}
    uri=${this.docUri}&year=${this.year}&number=${this.number}`;
    const documentInfo = await Vue.axios.get(url);
    this.documentInfo = documentInfo.data; */

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    onClick: function onClick() {
      if (arguments[0].data && arguments[0].data.docYear && arguments[0].data.docNumber && arguments[0].data.docType) {
        var path = '/pronuncia/' + arguments[0].data.docType + '/' + arguments[0].data.docYear + '/' + arguments[0].data.docNumber;
        this.$router.push({
          path: path
        });
        // eslint-disable-next-line no-undef
        $('#modal-document-info').modal('hide');
      }
    }
  },
  data: function data() {
    return {
      documentInfo: null,
      sunburst: null
    };
  }
});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_accessory_Spinner__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_accessory_Filters__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a, {
  slots: {
    spinner: __WEBPACK_IMPORTED_MODULE_3__components_layout_accessory_Spinner__["a" /* default */],
    noMore: '',
    noResults: ''
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocumentsList',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_layout_accessory_Spinner__["a" /* default */],
    Filters: __WEBPACK_IMPORTED_MODULE_4__components_layout_accessory_Filters__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
      start: this.documentsSetsStartFromDocumentSentenze,
      size: this.documentsSetsSize,
      type: 'sentenza'
    });
    this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
      start: this.documentsSetsStartFromDocumentOrdinanze,
      size: this.documentsSetsSize,
      type: 'ordinanza'
    });
  },

  methods: {
    getDownloadUrl: function getDownloadUrl(docUri, year, number) {
      var separator =  false ? '?' : '&';
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$proxy + 'getDocument.xq' + separator + 'uri=' + docUri + '&year=' + year + '&number=' + number;
    },
    filtersSet: function filtersSet() {
      var areFiltersSet = this.pronunceFilters.years.length || this.pronunceFilters.numbers.length || this.pronunceFilters.ecli.length || this.pronunceFilters.presidents.length || this.pronunceFilters.relators.length || this.pronunceFilters.judges.length;
      return areFiltersSet;
    },
    infiniteHandlerSentenze: function infiniteHandlerSentenze($state) {
      var _this = this;

      var supposedTotal = this.documentsSetsStartFromDocumentSentenze + (this.documentsSetsSize - 1);
      if (this.documentsList.sentenze.length === supposedTotal) {
        this.documentsSetsStartFromDocumentSentenze += this.documentsSetsSize;
        this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
          start: this.documentsSetsStartFromDocumentSentenze,
          size: this.documentsSetsSize,
          type: 'sentenza'
        }).then(function () {
          if (_this.documentsList.sentenze.length < _this.documentsList.totalSentenze) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      } else {
        $state.complete();
      }
    },
    infiniteHandlerOrdinanze: function infiniteHandlerOrdinanze($state) {
      var _this2 = this;

      var supposedTotal = this.documentsSetsStartFromDocumentOrdinanze + (this.documentsSetsSize - 1);
      if (this.documentsList.ordinanze.length === supposedTotal) {
        this.documentsSetsStartFromDocumentOrdinanze += this.documentsSetsSize;
        this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
          start: this.documentsSetsStartFromDocumentOrdinanze,
          size: this.documentsSetsSize,
          type: 'ordinanza'
        }).then(function () {
          if (_this2.documentsList.ordinanze.length < _this2.documentsList.totalOrdinanze) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      } else {
        $state.complete();
      }
    }
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['documentsList', 'presidenti', 'relatori', 'giudici', 'pronunceFilters', 'noResults']),
  data: function data() {
    return {
      // documentsList: [],
      documentsSetsStartFromDocumentSentenze: 1,
      sentenzeList: [],
      documentsSetsStartFromDocumentOrdinanze: 1,
      documentsSetsSize: 25,
      sortBy: 'age',
      sortDesc: false,
      icons: {
        itClose: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-close',
        itCalendar: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-calendar',
        itInfoCircle: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-info-circle',
        itArrowRight: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-arrow-right',
        itDownload: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-download',
        itPasswordVisible: __WEBPACK_IMPORTED_MODULE_5_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-password-visible'
      }
    };
  }
});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_italia_dist_svg_sprite_svg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_italia_dist_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_italia_dist_svg_sprite_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filters',
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['pronunceFilters']),
  methods: {
    deleteAllFilters: function deleteAllFilters() {
      var _this = this;

      this.$store.dispatch('EMPTY_PRONUNCE_FILTER').then(function () {
        _this.$store.dispatch('EMPTY_DOCUMENTS_LIST').then(function () {
          _this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: _this.documentsSetsStartFromDocumentSentenze,
            size: _this.documentsSetsSize,
            type: 'sentenza'
          });
          _this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: _this.documentsSetsStartFromDocumentOrdinanze,
            size: _this.documentsSetsSize,
            type: 'ordinanza'
          });
        });
      });
    },
    deleteFilter: function deleteFilter(type, index) {
      var _this2 = this;

      this.$store.dispatch('EMPTY_PRONUNCE_FILTER', {
        type: type,
        index: index
      }).then(function () {
        _this2.$store.dispatch('EMPTY_DOCUMENTS_LIST').then(function () {
          _this2.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: _this2.documentsSetsStartFromDocumentSentenze,
            size: _this2.documentsSetsSize,
            type: 'sentenza'
          });
          _this2.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: _this2.documentsSetsStartFromDocumentOrdinanze,
            size: _this2.documentsSetsSize,
            type: 'ordinanza'
          });
        });
      });
    }
  },
  data: function data() {
    return {
      icons: {
        itClose: __WEBPACK_IMPORTED_MODULE_1_bootstrap_italia_dist_svg_sprite_svg___default.a + '#it-close'
      }
    };
  }
});

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_Document__ = __webpack_require__(235);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pronuncia',
  components: {
    Document: __WEBPACK_IMPORTED_MODULE_0__components_pages_Document__["a" /* default */]
  },
  breadcrumb: {
    label: 'Pronuncia',
    parent: 'pronunce'
  },
  mounted: function mounted() {
    this.scrollToTop();
  },

  methods: {
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  },
  data: function data() {
    return {
      query: this.$route.query
    };
  }
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'informazioni',
  components: {},
  breadcrumb: {
    label: 'Informazioni',
    parent: 'home'
  },
  mounted: function mounted() {},

  computed: {},
  methods: {},
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gruppo-di-lavoro',
  components: {},
  breadcrumb: {
    label: 'Gruppo di Lavoro',
    parent: 'home'
  },
  mounted: function mounted() {},

  computed: {},
  methods: {},
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'guida-all-uso',
  components: {},
  breadcrumb: {
    label: 'Guida all\'uso',
    parent: 'home'
  },
  mounted: function mounted() {},

  computed: {},
  methods: {},
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_async_computed__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_2_crumbs__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_2_crumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_2_crumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_fragment__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_italia_dist_css_bootstrap_italia_min_css__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_italia_dist_css_bootstrap_italia_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_italia_dist_css_bootstrap_italia_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(670);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








// import 'bootstrap/dist/css/bootstrap.css';






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_async_computed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_2_crumbs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_fragment__["a" /* default */].Plugin);

// contextual properties
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$devProxy = '/api/exist/rest/db/portal-corte-costituzionale/';
// Vue.prototype.$prodProxy = 'http://bach.cirsfid.unibo.it:8081/exist/rest/db/portal-corte-costituzionale/';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$prodProxy = '/node/exist-proxy/?exist=8081&path=portal-corte-costituzionale/';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$proxy =  false ? Vue.prototype.$devProxy : __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$prodProxy;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */] }
});

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(61);




var _this = this;

/* eslint-disable no-param-reassign */
/* eslint-disable arrow-body-style */



__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  state: {
    latestPerYear: [],
    noResults: {
      sentenze: false,
      ordinanze: false
    },
    documentsList: {
      sentenze: [],
      ordinanze: [],
      totalSentenze: 0,
      totalOrdinanze: 0
    },
    presidenti: [],
    relatori: [],
    giudici: [],
    pronunceFilters: {
      years: [],
      numbers: [],
      ecli: [],
      presidents: [],
      relators: [],
      judges: []
    }
  },
  getters: {
    LATEST_PER_YEAR: function LATEST_PER_YEAR(state) {
      return state.latestPerYear;
    },
    DOCUMENTS_LIST: function DOCUMENTS_LIST(state) {
      return state.documentsList;
    },
    PRESIDENTI: function PRESIDENTI(state) {
      return state.presidenti;
    },
    RELATORI: function RELATORI(state) {
      return state.relatori;
    },
    GIUDICI: function GIUDICI(state) {
      return state.giudici;
    },
    FILTERS: function FILTERS(state) {
      return state.pronunceFilters;
    }
  },
  mutations: {
    ADD_YEAR: function ADD_YEAR(state, payload) {
      state.latestPerYear.push(payload);
    },
    ADD_DOCUMENTS_SET: function ADD_DOCUMENTS_SET(state, payload) {
      if (payload.type === 'sentenza') {
        state.documentsList.totalSentenze = payload.total;
        if (state.documentsList.totalSentenze > 0) {
          payload.docs.forEach(function (p) {
            state.documentsList.sentenze.push(p);
          });
        } else {
          state.noResults.sentenze = true;
        }
      } else if (payload.type === 'ordinanza') {
        state.documentsList.totalOrdinanze = payload.total;
        if (state.documentsList.totalOrdinanze > 0) {
          payload.docs.forEach(function (p) {
            state.documentsList.ordinanze.push(p);
          });
        } else {
          state.noResults.ordinanze = true;
        }
      }
    },
    DELETE_DOCUMENTS_SET: function DELETE_DOCUMENTS_SET(state, payload) {
      if (!payload) {
        state.noResults.sentenze = false;
        state.noResults.ordinanze = false;
        state.documentsList.sentenze = [];
        state.documentsList.ordinanze = [];
        state.documentsList.totalSentenze = 0;
        state.documentsList.totalOrdinanze = 0;
      }
    },
    ADD_PRESIDENTE_SET: function ADD_PRESIDENTE_SET(state, payload) {
      state.presidenti = payload;
    },
    ADD_RELATORE_SET: function ADD_RELATORE_SET(state, payload) {
      state.relatori = payload;
    },
    ADD_GIUDICE_SET: function ADD_GIUDICE_SET(state, payload) {
      state.giudici = payload;
    },
    ADD_PRONUNCE_FILTER: function ADD_PRONUNCE_FILTER(state, payload) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(payload.filters).forEach(function (e) {
        state.pronunceFilters[e[0]] = e[1];
      });
    },
    DELETE_PRONUNCE_FILTER: function DELETE_PRONUNCE_FILTER(state, payload) {
      if (!payload) {
        state.pronunceFilters.years = [];
        state.pronunceFilters.numbers = [];
        state.pronunceFilters.ecli = [];
        state.pronunceFilters.presidents = [];
        state.pronunceFilters.relators = [];
        // state.pronunceFilters.judges = [];
      } else {
        state.pronunceFilters[payload.type].splice(payload.index, 1);
      }
    }
  },
  actions: {
    SAVE_YEAR: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, payload) {
        var _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$proxy + 'getLatestPerYear.xq', {
                  params: {
                    year: payload
                  }
                });

              case 2:
                _ref2 = _context.sent;
                data = _ref2.data;

                data.year = payload;
                context.commit('ADD_YEAR', data);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function SAVE_YEAR(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(),
    SAVE_DOCUMENTS_LIST: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, payload) {
        var _ref4, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$proxy + 'getDocumentsList.xq', {
                  params: {
                    start: payload.start,
                    size: payload.size,
                    type: payload.type,
                    years: context.state.pronunceFilters.years.join(','),
                    presidents: context.state.pronunceFilters.presidents.join(','),
                    relators: context.state.pronunceFilters.relators.join(',')
                    // judges: context.state.pronunceFilters.judges.join(','),
                  }
                });

              case 2:
                _ref4 = _context2.sent;
                data = _ref4.data;

                data.type = payload.type;
                context.commit('ADD_DOCUMENTS_SET', data);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function SAVE_DOCUMENTS_LIST(_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }(),
    EMPTY_DOCUMENTS_LIST: function EMPTY_DOCUMENTS_LIST(context, payload) {
      context.commit('DELETE_DOCUMENTS_SET', payload);
    },
    SAVE_PEOPLE_LIST: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(context, payload) {
        var _ref6, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$proxy + 'allPeople.xq', {
                  params: {
                    role: payload.role
                  }
                });

              case 2:
                _ref6 = _context3.sent;
                data = _ref6.data;

                if (payload.role === 'presidente') {
                  context.commit('ADD_PRESIDENTE_SET', data);
                } else if (payload.role === 'relatore') {
                  context.commit('ADD_RELATORE_SET', data);
                } else if (payload.role === 'giudice') {
                  context.commit('ADD_GIUDICE_SET', data);
                }

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function SAVE_PEOPLE_LIST(_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }(),
    SAVE_PRONUNCE_FILTER: function SAVE_PRONUNCE_FILTER(context, payload) {
      context.commit('ADD_PRONUNCE_FILTER', payload);
    },
    EMPTY_PRONUNCE_FILTER: function EMPTY_PRONUNCE_FILTER(context, payload) {
      context.commit('DELETE_PRONUNCE_FILTER', payload);
    }
  }
}));

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d9fd859_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(669);
function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d9fd859_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 627:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderMain_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e9bf8b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderMain_vue__ = __webpack_require__(640);
function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e9bf8b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e9bf8b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 630:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderTop_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e05fab2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderTop_vue__ = __webpack_require__(633);
function injectStyle (ssrContext) {
  __webpack_require__(632)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e05fab2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e05fab2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 632:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"it-header-slim-wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"it-header-slim-wrapper-content"},[_c('a',{staticClass:"d-none d-lg-block navbar-brand",attrs:{"href":"#"}},[_vm._v("CIRSFID, ALMA MATER STUDIORUM - Università di Bologna")]),_vm._v(" "),_c('div',{staticClass:"nav-mobile"},[_c('nav',[_c('a',{staticClass:"it-opener d-lg-none",attrs:{"data-toggle":"collapse","href":"#menu4","role":"button","aria-expanded":"false","aria-controls":"menu4"}},[_vm._v("\n                ALMA MATER STUDIORUM - Università di Bologna - CIRSFID\n                "),_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itExpand}})])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"header-slim-right-zone"},[_c('div',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"aria-expanded":"false","data-toggle":"dropdown","href":"#"}},[_c('span',[_vm._v("ITA")]),_vm._v(" "),_c('svg',{staticClass:"icon icon-white d-none d-lg-block"},[_c('use',{attrs:{"xlink:href":_vm.icons.itExpand}})])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary btn-icon btn-full",attrs:{"href":"#","title":"Accedi all'area personale"}},[_c('span',{staticClass:"rounded-icon"},[_c('svg',{staticClass:"icon icon-primary"},[_c('use',{attrs:{"xlink:href":_vm.icons.itUser}})])]),_vm._v(" "),_c('span',{staticClass:"d-none d-lg-block"},[_vm._v("Accedi all'area personale")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-list-wrapper collapse",attrs:{"id":"menu4"}},[_c('ul',{staticClass:"link-list"},[_c('li',[_c('a',{attrs:{"href":"http://www.cirsfid.unibo.it/","target":"_blank"}},[_vm._v("Sito Cirsfid")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.cortecostituzionale.it/default.do","target":"_blank"}},[_vm._v("Sito Corte Costituzionale")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"link-list-wrapper"},[_c('ul',{staticClass:"link-list"},[_c('li',[_c('a',{staticClass:"list-item",attrs:{"href":"#"}},[_c('span',[_vm._v("ITA")])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"list-item",attrs:{"href":"#"}},[_c('span',[_vm._v("ENG")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderCenter_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_974a3628_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderCenter_vue__ = __webpack_require__(636);
function injectStyle (ssrContext) {
  __webpack_require__(635)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-974a3628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderCenter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_974a3628_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderCenter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 635:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"it-header-center-wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"it-header-center-content-wrapper"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"it-right-zone"},[_c('div',{staticClass:"it-search-wrapper"},[_c('span',{staticClass:"d-none d-md-block"},[_vm._v("Cerca")]),_vm._v(" "),_c('a',{staticClass:"search-link rounded-icon",attrs:{"aria-label":"Cerca","href":"#","data-toggle":"modal","data-target":"#modalsearch"}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itSearch}})])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"it-brand-wrapper"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"id":"unibo-logo-header","src":"static/logo.svg","alt":"Torna alla pagina iniziale"}}),_vm._v(" "),_c('div',{staticClass:"it-brand-text"},[_c('h2',{staticClass:"no_toc"},[_vm._v("Pronunce della Corte Costituzionale")]),_vm._v(" "),_c('h3',{staticClass:"no_toc d-md-block"},[_vm._v("\n                  Versione Akoma Ntoso a cura del CIRSFID, Università di Bologna\n                ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderBottom_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9e0079_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderBottom_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(638)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e9e0079"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderBottom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9e0079_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderBottom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 638:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"it-header-navbar-wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('nav',{staticClass:"navbar navbar-expand-lg has-megamenu"},[_c('button',{staticClass:"custom-navbar-toggler",attrs:{"aria-controls":"nav10","aria-expanded":"false","aria-label":"Toggle navigation","data-target":"#nav10","type":"button"}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itBurger}})])]),_vm._v(" "),_c('div',{staticClass:"navbar-collapsable",attrs:{"id":"nav10"}},[_c('div',{staticClass:"overlay"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"menu-wrapper"},[_c('ul',{staticClass:"navbar-nav"},[_c('li',{staticClass:"nav-item "},[_c('router-link',{staticClass:"spacing nav-link",class:{active:_vm.activePage['home']},attrs:{"to":"/"}},[_c('span',[_vm._v("Home")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item "},[_c('router-link',{staticClass:"spacing nav-link",class:{active:_vm.activePage['pronunce']},attrs:{"to":"/pronunce"}},[_c('span',[_vm._v("Pronunce")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item "},[_c('router-link',{staticClass:"spacing nav-link",class:{active:_vm.activePage['informazioni']},attrs:{"to":"/informazioni"}},[_c('span',[_vm._v("Informazioni")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item "},[_c('router-link',{staticClass:"spacing nav-link",class:{active:_vm.activePage['gruppo-di-lavoro']},attrs:{"to":"/gruppo-di-lavoro"}},[_c('span',[_vm._v("Gruppo di Lavoro")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item "},[_c('router-link',{staticClass:"spacing nav-link",class:{active:_vm.activePage['guida-all-uso']},attrs:{"to":"/guida-all-uso"}},[_c('span',[_vm._v("Guida all'uso")])])],1)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-div sr-only"},[_c('button',{staticClass:"btn close-menu",attrs:{"type":"button"}},[_c('span',{staticClass:"it-close"}),_vm._v("close\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"it-header-wrapper it-header-sticky"},[_c('HeaderTop'),_vm._v(" "),_c('div',{staticClass:"it-nav-wrapper"},[_c('HeaderCenter'),_vm._v(" "),_c('HeaderBottom')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterMain_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1082fc94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterMain_vue__ = __webpack_require__(649);
function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1082fc94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1082fc94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 642:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterTop_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfe9e820_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterTop_vue__ = __webpack_require__(645);
function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bfe9e820"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfe9e820_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 644:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"it-footer-main"},[_c('div',{staticClass:"container"},[_c('section',[_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"it-brand-wrapper"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"id":"unibo-logo-footer","src":"static/logo.svg","alt":"Torna alla pagina iniziale"}}),_vm._v(" "),_c('div',{staticClass:"it-brand-text"},[_c('h2',{staticClass:"no_toc"},[_vm._v("CIRSFID, ALMA MATER STUDIORUM - Università di Bologna")]),_vm._v(" "),_c('h3',{staticClass:"no_toc d-none d-md-block"},[_vm._v("\n                  Portali per la visualizzazione di documenti giuridici\n                ")])])])])])])]),_vm._v(" "),_c('section',{staticClass:"py-4 border-white border-top"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6 pb-1"},[_c('h4',[_c('a',{attrs:{"href":"#","title":"Vai alla pagina: Amministrazione"}},[_vm._v("Amministrazione trasparente")])]),_vm._v(" "),_c('p',[_vm._v("\n            I dati personali pubblicati sono riutilizzabili solo alle\n            condizioni previste dalla direttiva comunitaria 2003/98/CE e dal\n            d.lgs. 36/2006\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 pb-1"},[_c('h4',[_c('a',{attrs:{"href":"#","title":"Vai alla pagina: Contatti"}},[_vm._v("Contatti")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Luca Cevone, Monica Palmirani")]),_c('br'),_vm._v("\n            CIRSFID, Via Galliera 3, 40122 Bologna\n          ")]),_vm._v(" "),_c('div',{staticClass:"link-list-wrapper"},[_c('ul',{staticClass:"footer-list link-list clearfix"},[_c('li',[_c('a',{staticClass:"list-item",attrs:{"href":"mailto:luca.cervone@unibo.it","title":"Mail a: Luca Cervone"}},[_vm._v("luca.cervone@unibo.it")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"list-item",attrs:{"href":"mailto:monica.palmirani@unibo.it","title":"Mail a: Monica Palmirani"}},[_vm._v("monica.palmirani@unibo.it")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterBottom_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f149a6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterBottom_vue__ = __webpack_require__(648);
function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f149a6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterBottom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f149a6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterBottom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 647:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"it-footer-small-prints clearfix"},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"sr-only"},[_vm._v("Sezione Link Utili")]),_vm._v(" "),_c('ul',{staticClass:"it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row"},[_c('li',{staticClass:"list-inline-item"},[_c('a',{attrs:{"href":"#","title":"Note Legali"}},[_vm._v("Note legali")])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('a',{attrs:{"href":"#","title":"Privacy-Cookies"}},[_vm._v("Privacy policy")])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('a',{attrs:{"href":"#","title":"Mappa del sito"}},[_vm._v("Mappa del sito")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"it-footer"},[_c('FooterTop'),_vm._v(" "),_c('FooterBottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessoryMain_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd546394_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessoryMain_vue__ = __webpack_require__(668);
function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd546394"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessoryMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd546394_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessoryMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 651:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackToTopButton_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270c6bfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackToTopButton_vue__ = __webpack_require__(654);
function injectStyle (ssrContext) {
  __webpack_require__(653)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackToTopButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270c6bfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackToTopButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 653:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back-to-top",attrs:{"href":"#","aria-hidden":"true","data-attribute":"back-to-top"}},[_c('svg',{staticClass:"icon icon-light"},[_c('use',{attrs:{"xlink:href":_vm.icons.itArrowUp}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalSearch_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f13f38_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalSearch_vue__ = __webpack_require__(664);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f13f38_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 656:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchForm_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_213d7274_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchForm_vue__ = __webpack_require__(663);
function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-213d7274"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_213d7274_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 658:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-spinner progress-spinner-active mx-auto text-center"},[_c('span',{staticClass:"sr-only"},[_vm._v("Caricamento...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-lg-12 px-lg-12 py-lg-12"},[(_vm.relatori.person)?_c('div',[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"range-label",attrs:{"for":"years-range"}},[_vm._v("Intervallo Di Annate")]),_vm._v(" "),_c('div',{staticClass:"form-group col-lg-12 px-lg-12 py-lg-12",attrs:{"id":"year-form-group"}},[_c('vue-slider',{ref:"yearsRange",attrs:{"id":"years-range","value":_vm.defaultYearsRange,"min":_vm.minYear,"max":_vm.maxYear,"enable-cross":false,"contained":true,"tooltip":'always',"tooltip-placement":'bottom'},on:{"drag-end":function($event){return _vm.selectYears()}}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_vm._l((_vm.filters.presidents),function(president,$index){return _c('div',{key:$index,staticClass:"chip presidente-bg"},[_c('span',{staticClass:"chip-label text-white"},[_c('em',[_vm._v("presidente")]),_vm._v(": "+_vm._s(president))]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.deleteFilter('presidents', $index)}}},[_c('svg',{staticClass:"icon white"},[_c('use',{attrs:{"xlink:href":_vm.icons.itClose}})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Elimina filtro")])])])}),_vm._v(" "),(_vm.presidenti.person)?_c('div',{staticClass:"form-group col-lg-12 px-lg-12 py-lg-12",attrs:{"id":"autocomplete-presidente-form-group"},on:{"click":_vm.autocompleteClicked}},[_c('input',{ref:"autocompletePresidente",staticClass:"autocomplete",attrs:{"type":"search","placeholder":"Cerca Presidente","id":"autocomplete-presidente","name":"autocomplete-presidente","data-autocomplete":JSON.stringify(_vm.presidenti.person)}}),_vm._v(" "),_c('span',{staticClass:"autocomplete-icon",attrs:{"aria-hidden":"true"}},[_c('svg',{staticClass:"icon icon-sm align-bottom"},[_c('use',{attrs:{"xlink:href":_vm.icons.itUser}})])]),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"autocomplete-presidente"}},[_vm._v("Cerca i presidenti")])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-row"},[_vm._l((_vm.filters.relators),function(relator,$index){return _c('div',{key:$index,staticClass:"chip relatore-bg"},[_c('span',{staticClass:"chip-label text-white"},[_c('em',[_vm._v("relatore")]),_vm._v(": "+_vm._s(relator))]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.deleteFilter('relators', $index)}}},[_c('svg',{staticClass:"icon white"},[_c('use',{attrs:{"xlink:href":_vm.icons.itClose}})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Elimina filtro")])])])}),_vm._v(" "),(_vm.relatori.person)?_c('div',{staticClass:"form-group col-lg-12 px-lg-12 py-lg-12",attrs:{"id":"autocomplete-relatori-form-group"},on:{"click":_vm.autocompleteClicked}},[_c('input',{ref:"autocompleteRelatore",staticClass:"autocomplete",attrs:{"type":"search","placeholder":"Cerca Relatore","id":"autocomplete-relatore","name":"autocomplete-relatore","data-autocomplete":JSON.stringify(_vm.relatori.person)}}),_vm._v(" "),_c('span',{staticClass:"autocomplete-icon",attrs:{"aria-hidden":"true"}},[_c('svg',{staticClass:"icon icon-sm align-bottom"},[_c('use',{attrs:{"xlink:href":_vm.icons.itUser}})])]),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"autocomplete-relatore"}},[_vm._v("Cerca i relatori")])]):_vm._e()],2)]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-lg-12 py-lg-12"},[(!_vm.presidenti.person && !_vm.relatori.person)?_c('h6',[_vm._v("\n            Dammi qualche secondo, sto scaricando dati utili alla ricerca!\n          ")]):_c('h6',[_vm._v("\n            Ancora un attimo, ci siamo quasi ....\n          ")]),_vm._v(" "),_c('Spinner')],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal it-dialog-scrollable fade",attrs:{"tabindex":"-1","role":"dialog","id":"modalsearch"}},[_c('div',{staticClass:"modal-dialog modal-dialog-right",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Cerca tra le Sentenze e le Ordinanze della Corte Costituzionale\n            ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itClose}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('SearchForm',{ref:"searchForm"})],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm float-left",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteFilters()}}},[_vm._v("Cancella tutti i filtri")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.filterPronunce()}}},[_vm._v("Cerca")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BreadCrumbs_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba48ed42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BreadCrumbs_vue__ = __webpack_require__(667);
function injectStyle (ssrContext) {
  __webpack_require__(666)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BreadCrumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba48ed42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BreadCrumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 666:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activePage!=='home')?_c('section',{staticClass:"container px-4 my-4",attrs:{"id":"briciole"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col px-lg-4"},[_c('nav',{staticClass:"breadcrumb-container",attrs:{"aria-label":"breadcrumb"}},[_c('app-breadcrumbs',{staticClass:"breadcrumb",attrs:{"container":"ol","aria-label":"breadcrumb"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var to = ref.to;
var label = ref.label;
var utils = ref.utils;
return _c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{staticClass:"your-custom-class",attrs:{"to":to,"exact":"","itemprop":utils && utils.itemprop}},[_vm._v(_vm._s(label))]),_vm._v(" "),_c('span',{staticClass:"separator"},[_vm._v("/")])],1)}},{key:"current",fn:function(ref){
var label = ref.label;
return _c('span',{staticClass:"custom-current-class"},[_vm._v(_vm._s(label))])}}],null,false,2498791327)})],1)])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"accessory-container"}},[_c('BackToTopButton'),_vm._v(" "),_c('ModalSearch'),_vm._v(" "),_c('BreadCrumbs')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('HeaderMain'),_vm._v(" "),_c('main',{staticClass:"affix-parent"},[_c('AccessoryMain'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('FooterMain')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Home__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Pronunce__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Pronuncia__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Informazioni__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_GruppoDiLavoro__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_GuidaAllUso__ = __webpack_require__(883);


// import Document from '@/components/pages/Document';







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Home__["a" /* default */]
  }, {
    path: '/pronunce',
    name: 'pronunce',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Pronunce__["a" /* default */]
  }, {
    path: '/pronuncia/:type/:year/:number',
    name: 'pronuncia',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_Pronuncia__["a" /* default */]
  }, {
    path: '/informazioni',
    name: 'informazioni',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Informazioni__["a" /* default */]
  }, {
    path: '/gruppo-di-lavoro',
    name: 'gruppo-di-lavoro',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_GruppoDiLavoro__["a" /* default */]
  }, {
    path: '/guida-all-uso',
    name: 'guida-all-uso',
    component: __WEBPACK_IMPORTED_MODULE_7__components_pages_GuidaAllUso__["a" /* default */]
  }]
}));

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3f76fa2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(678);
function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3f76fa2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3f76fa2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 673:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearCards_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_888a74a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearCards_vue__ = __webpack_require__(677);
function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-888a74a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_888a74a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 675:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"in-evidenza"}},[_c('div',{staticClass:"bg-100 py-5"},[_c('div',{staticClass:"container px-4"},[_vm._m(0),_vm._v(" "),(_vm.getLatestYear())?_c('div',{staticClass:"row"},_vm._l((_vm.getLatestYear()),function(item){return _c('div',{key:item.year,staticClass:"col-12 col-sm-6 col-lg-4"},[_c('article',{staticClass:"card-wrapper card-space",on:{"click":function($event){return _vm.test()}}},[_c('div',{staticClass:"card card-bg card-big rounded shadow"},[_c('div',{staticClass:"etichetta"},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itCalendar}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.year))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Nel "+_vm._s(item.year)+", la Corte Costituzionale ha pronunciato")]),_vm._v(" "),_c('span',{staticClass:"badge badge-pill sentenze-bg"},[_vm._v(_vm._s(item.sentenze)+" sentenze")]),_vm._v(" "),_c('span',{staticClass:"badge badge-pill ordinanze-bg"},[_vm._v(_vm._s(item.ordinanze)+" ordinanze")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.goToPronunce($event, item.year)}}},[_vm._v("\n                      Consulta le pronunce del "+_vm._s(item.year)+"\n                  ")])]),_vm._v(" "),_c('a',{staticClass:"read-more",attrs:{"href":_vm.getGitHubLink(item.year),"target":"_blank"}},[_c('span',{staticClass:"text"},[_vm._v("Oppure scarica l'intera annata "+_vm._s(item.year))]),_vm._v(" "),_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itArrowRight}})])])])])])])}),0):_c('div',{staticClass:"row"},[_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',{staticClass:"mb-4 text-primary"},[_vm._v("Tutte le pronunce per anno")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-12"},[_c('div',{staticClass:"progress-spinner progress-spinner-active"},[_c('span',{staticClass:"sr-only"},[_vm._v("Caricamento...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"document"}},[_c('section',{staticClass:"container px-4 my-4",attrs:{"id":"intro"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-lg-12 py-lg-12"},[_c('h1',[_vm._v("Pronunce Della Corte Costituzionale")]),_vm._v(" "),_c('p',[_vm._v("\n          Tutte le pronunce della Corte Costituzionale marcate in Akoma Ntoso.\n        ")]),_vm._v(" "),_c('h5',[_vm._v("Cosa puoi fare adesso?")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Consulta il catalogo completo in formato Akoma Ntoso nella sezione "),_c('router-link',{attrs:{"to":"/pronunce"}},[_vm._v("\"Pronunce\"")]),_vm._v(".")],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('li',[_vm._v("Consulta le pronunce a partire dalle annate elencate qui sotto.")]),_vm._v(" "),_c('li',[_vm._v("Scarica le annate elencate qui sotto nel formato Akoma Ntoso.")])])])])]),_vm._v(" "),_c('YearCards')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._v("Fai una ricerca mirata "),_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#modalsearch"}},[_vm._v(" cliccando qui")]),_vm._v(" oppure sul pulsante di ricerca in alto a destra.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pronunce_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a5f3099_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pronunce_vue__ = __webpack_require__(873);
function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a5f3099"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pronunce_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a5f3099_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pronunce_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 680:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

module.exports = {"docTypes":{"amendmentList":{"indexOn":{"coverPage":true,"preface":true,"preamble":true,"collectionBody":true,"conclusions":true,"attachments":true}},"officialGazette":{"indexOn":{"coverPage":true,"preface":true,"preamble":true,"collectionBody":true,"conclusions":true,"attachments":true}},"documentCollection":{"indexOn":{"coverPage":true,"preface":true,"preamble":true,"collectionBody":true,"conclusions":true,"attachments":true}},"act":{"indexOn":{"coverPage":true,"preface":true,"preamble":true,"body":true,"conclusions":true,"attachments":true}},"bill":{"indexOn":{"coverPage":true,"preface":true,"preamble":true,"body":true,"conclusions":true,"attachments":true}},"debateReport":{"indexOn":{"coverPage":true,"preface":true,"preamble":true,"mainBody":true,"conclusions":true,"attachments":true}},"debate":{"indexOn":{"coverPage":true,"preface":true,"preamble":true,"debateBody":true,"conclusions":true,"attachments":true}},"statement":{"indexOn":{"coverPage":true,"preface":true,"preamble":true,"mainBody":true,"conclusions":true,"attachments":true}},"amendment":{"indexOn":{"coverPage":true,"preface":true,"preamble":true,"amendmentBody":true,"conclusions":true,"attachments":true}},"judgment":{"indexOn":{"coverPage":true,"header":true,"judgmentBody":true,"conclusions":true,"attachments":true}},"portion":{"indexOn":{"portionBody":true}},"doc":{"indexOn":{"coverPage":true,"preface":true,"preamble":true,"mainBody":true,"conclusions":true,"attachments":true}}}}

/***/ }),

/***/ 714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AknVisualizer_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f80dafb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AknVisualizer_vue__ = __webpack_require__(719);
function injectStyle (ssrContext) {
  __webpack_require__(715)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f80dafb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AknVisualizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f80dafb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AknVisualizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 715:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"aknDom",staticClass:"aknVisualizer",attrs:{"id":"aknVisualizer","data-theme":_vm.theme},domProps:{"innerHTML":_vm._s(_vm.aknDOM)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 720:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDocument_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1457b8c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDocument_vue__ = __webpack_require__(726);
function injectStyle (ssrContext) {
  __webpack_require__(721)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c1457b8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDocument_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1457b8c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDocument_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 721:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueScrollProgressBar_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7a1d133c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueScrollProgressBar_vue__ = __webpack_require__(725);
function injectStyle (ssrContext) {
  __webpack_require__(724)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a1d133c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueScrollProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7a1d133c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueScrollProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 724:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass,style:({
    background: _vm.containerColor,
    zIndex: _vm.zIndex
  })},[_c('div',{class:_vm.barClass,style:({
      width: (_vm.width + "%"),
      height: _vm.height,
      background: _vm.backgroundColor
    })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc-header container-fluid container-fluid--desktop bg-white sticky-top"},[_c('div',{staticClass:"row py-3 px-4 px-lg-5 align-items-center flex-nowrap justify-content-between"},[_c('div',{staticClass:"col-4 d-flex flex-md-grow-1 order-0 order-md-1 pl-0"},[_c('a',{staticClass:"document-ingo-link btn p-2 btn-outline-primary",attrs:{"aria-label":"Informazioni Sula Pronuncia","href":"#","data-toggle":"modal","data-target":"#modal-document-info","role":"button"}},[_c('span',{staticClass:"info-icon icon-primary",attrs:{"aria-hidden":"true"}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itInfoCircle}})])]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-inline align-middle"},[_vm._v("Informazioni Sulla Pronuncia")])])]),_vm._v(" "),_c('div',{staticClass:"col-4 col-sm-auto d-flex flex-md-grow-1 align-items-center justify-content-center order-1"},[_c('div',{staticClass:"px-2",attrs:{"id":"rst-menu"}},[_c('div',{staticClass:"dropdown",attrs:{"id":"version-list"}},[_c('button',{staticClass:"btn btn-outline-primary dropdown-toggle text-nowrap",attrs:{"type":"button","id":"dropdownVersionButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('span',{staticClass:"current-version"},[_vm._v("Versioni")]),_vm._v(" "),_c('span',{staticClass:"info-icon icon-primary",attrs:{"aria-hidden":"true"}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itArrowDownTriangle}})])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownVersionButton"}},[_c('div',{staticClass:"version-list-wrapper"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":("#" + (this.$router.currentRoute.path)),"disabled":""}},[_vm._v("Versione Unica")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 d-none d-md-flex flex-grow-1 align-items-center order-1"},[_c('div',{staticClass:"document-actions d-flex flex-column flex-md-row justify-content-around w-100 p-2 p-md-0 text-blue"},[_c('div',{staticClass:"p-3 px-md-2 py-md-0"},[_c('a',{staticClass:"btn p-2 btn-outline-primary",attrs:{"href":_vm.getDownloadUrl(_vm.docUri),"role":"button","target":"_blank"}},[_c('span',{staticClass:"info-icon icon-primary",attrs:{"aria-hidden":"true"}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itCodeCircle}})])]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-inline align-middle"},[_vm._v("Download Akoma Ntoso")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-3 pr-0 d-md-none d-flex align-items-center justify-content-end order-1"},[_c('a',{staticClass:"btn p-2 btn-outline-primary",attrs:{"href":_vm.getDownloadUrl(_vm.docUri),"role":"button","target":"_blank"}},[_c('span',{staticClass:"info-icon icon-primary",attrs:{"aria-hidden":"true"}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itCodeCircle}})])]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-inline align-middle"},[_vm._v("Download Akoma Ntoso")])])])]),_vm._v(" "),_c('VueScrollProgressBar',{attrs:{"containerClass":_vm.scrollContainerClass,"barClass":_vm.scrollBarClass,"height":"4px","backgroundColor":"undefined"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 727:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDocumentInfo_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03860a8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDocumentInfo_vue__ = __webpack_require__(864);
function injectStyle (ssrContext) {
  __webpack_require__(728)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDocumentInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03860a8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDocumentInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 728:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 729:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLegislazione_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e534b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartLegislazione_vue__ = __webpack_require__(860);
function injectStyle (ssrContext) {
  __webpack_require__(730)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34e534b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLegislazione_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e534b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartLegislazione_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 730:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 247,
	"./af.js": 247,
	"./ar": 248,
	"./ar-dz": 249,
	"./ar-dz.js": 249,
	"./ar-kw": 250,
	"./ar-kw.js": 250,
	"./ar-ly": 251,
	"./ar-ly.js": 251,
	"./ar-ma": 252,
	"./ar-ma.js": 252,
	"./ar-sa": 253,
	"./ar-sa.js": 253,
	"./ar-tn": 254,
	"./ar-tn.js": 254,
	"./ar.js": 248,
	"./az": 255,
	"./az.js": 255,
	"./be": 256,
	"./be.js": 256,
	"./bg": 257,
	"./bg.js": 257,
	"./bm": 258,
	"./bm.js": 258,
	"./bn": 259,
	"./bn.js": 259,
	"./bo": 260,
	"./bo.js": 260,
	"./br": 261,
	"./br.js": 261,
	"./bs": 262,
	"./bs.js": 262,
	"./ca": 263,
	"./ca.js": 263,
	"./cs": 264,
	"./cs.js": 264,
	"./cv": 265,
	"./cv.js": 265,
	"./cy": 266,
	"./cy.js": 266,
	"./da": 267,
	"./da.js": 267,
	"./de": 268,
	"./de-at": 269,
	"./de-at.js": 269,
	"./de-ch": 270,
	"./de-ch.js": 270,
	"./de.js": 268,
	"./dv": 271,
	"./dv.js": 271,
	"./el": 272,
	"./el.js": 272,
	"./en-SG": 273,
	"./en-SG.js": 273,
	"./en-au": 274,
	"./en-au.js": 274,
	"./en-ca": 275,
	"./en-ca.js": 275,
	"./en-gb": 276,
	"./en-gb.js": 276,
	"./en-ie": 277,
	"./en-ie.js": 277,
	"./en-il": 278,
	"./en-il.js": 278,
	"./en-nz": 279,
	"./en-nz.js": 279,
	"./eo": 280,
	"./eo.js": 280,
	"./es": 281,
	"./es-do": 282,
	"./es-do.js": 282,
	"./es-us": 283,
	"./es-us.js": 283,
	"./es.js": 281,
	"./et": 284,
	"./et.js": 284,
	"./eu": 285,
	"./eu.js": 285,
	"./fa": 286,
	"./fa.js": 286,
	"./fi": 287,
	"./fi.js": 287,
	"./fo": 288,
	"./fo.js": 288,
	"./fr": 289,
	"./fr-ca": 290,
	"./fr-ca.js": 290,
	"./fr-ch": 291,
	"./fr-ch.js": 291,
	"./fr.js": 289,
	"./fy": 292,
	"./fy.js": 292,
	"./ga": 293,
	"./ga.js": 293,
	"./gd": 294,
	"./gd.js": 294,
	"./gl": 295,
	"./gl.js": 295,
	"./gom-latn": 296,
	"./gom-latn.js": 296,
	"./gu": 297,
	"./gu.js": 297,
	"./he": 298,
	"./he.js": 298,
	"./hi": 299,
	"./hi.js": 299,
	"./hr": 300,
	"./hr.js": 300,
	"./hu": 301,
	"./hu.js": 301,
	"./hy-am": 302,
	"./hy-am.js": 302,
	"./id": 303,
	"./id.js": 303,
	"./is": 304,
	"./is.js": 304,
	"./it": 305,
	"./it-ch": 306,
	"./it-ch.js": 306,
	"./it.js": 305,
	"./ja": 307,
	"./ja.js": 307,
	"./jv": 308,
	"./jv.js": 308,
	"./ka": 309,
	"./ka.js": 309,
	"./kk": 310,
	"./kk.js": 310,
	"./km": 311,
	"./km.js": 311,
	"./kn": 312,
	"./kn.js": 312,
	"./ko": 313,
	"./ko.js": 313,
	"./ku": 314,
	"./ku.js": 314,
	"./ky": 315,
	"./ky.js": 315,
	"./lb": 316,
	"./lb.js": 316,
	"./lo": 317,
	"./lo.js": 317,
	"./lt": 318,
	"./lt.js": 318,
	"./lv": 319,
	"./lv.js": 319,
	"./me": 320,
	"./me.js": 320,
	"./mi": 321,
	"./mi.js": 321,
	"./mk": 322,
	"./mk.js": 322,
	"./ml": 323,
	"./ml.js": 323,
	"./mn": 324,
	"./mn.js": 324,
	"./mr": 325,
	"./mr.js": 325,
	"./ms": 326,
	"./ms-my": 327,
	"./ms-my.js": 327,
	"./ms.js": 326,
	"./mt": 328,
	"./mt.js": 328,
	"./my": 329,
	"./my.js": 329,
	"./nb": 330,
	"./nb.js": 330,
	"./ne": 331,
	"./ne.js": 331,
	"./nl": 332,
	"./nl-be": 333,
	"./nl-be.js": 333,
	"./nl.js": 332,
	"./nn": 334,
	"./nn.js": 334,
	"./pa-in": 335,
	"./pa-in.js": 335,
	"./pl": 336,
	"./pl.js": 336,
	"./pt": 337,
	"./pt-br": 338,
	"./pt-br.js": 338,
	"./pt.js": 337,
	"./ro": 339,
	"./ro.js": 339,
	"./ru": 340,
	"./ru.js": 340,
	"./sd": 341,
	"./sd.js": 341,
	"./se": 342,
	"./se.js": 342,
	"./si": 343,
	"./si.js": 343,
	"./sk": 344,
	"./sk.js": 344,
	"./sl": 345,
	"./sl.js": 345,
	"./sq": 346,
	"./sq.js": 346,
	"./sr": 347,
	"./sr-cyrl": 348,
	"./sr-cyrl.js": 348,
	"./sr.js": 347,
	"./ss": 349,
	"./ss.js": 349,
	"./sv": 350,
	"./sv.js": 350,
	"./sw": 351,
	"./sw.js": 351,
	"./ta": 352,
	"./ta.js": 352,
	"./te": 353,
	"./te.js": 353,
	"./tet": 354,
	"./tet.js": 354,
	"./tg": 355,
	"./tg.js": 355,
	"./th": 356,
	"./th.js": 356,
	"./tl-ph": 357,
	"./tl-ph.js": 357,
	"./tlh": 358,
	"./tlh.js": 358,
	"./tr": 359,
	"./tr.js": 359,
	"./tzl": 360,
	"./tzl.js": 360,
	"./tzm": 361,
	"./tzm-latn": 362,
	"./tzm-latn.js": 362,
	"./tzm.js": 361,
	"./ug-cn": 363,
	"./ug-cn.js": 363,
	"./uk": 364,
	"./uk.js": 364,
	"./ur": 365,
	"./ur.js": 365,
	"./uz": 366,
	"./uz-latn": 367,
	"./uz-latn.js": 367,
	"./uz.js": 366,
	"./vi": 368,
	"./vi.js": 368,
	"./x-pseudo": 369,
	"./x-pseudo.js": 369,
	"./yo": 370,
	"./yo.js": 370,
	"./zh-cn": 371,
	"./zh-cn.js": 371,
	"./zh-hk": 372,
	"./zh-hk.js": 372,
	"./zh-tw": 373,
	"./zh-tw.js": 373
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 731;

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fe47632_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__(661);
function injectStyle (ssrContext) {
  __webpack_require__(660)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fe47632"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fe47632_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 814:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echarts"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 860:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sunburst)?_c('v-chart',{attrs:{"options":_vm.sunburst},on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartGiurisprudenza_vue__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4bd59c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartGiurisprudenza_vue__ = __webpack_require__(863);
function injectStyle (ssrContext) {
  __webpack_require__(862)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a4bd59c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartGiurisprudenza_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4bd59c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartGiurisprudenza_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 862:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sunburst)?_c('v-chart',{attrs:{"options":_vm.sunburst},on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 864:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modalInfo",staticClass:"modal it-dialog-scrollable fade",attrs:{"tabindex":"-1","role":"dialog","id":"modal-document-info"}},[_c('div',{staticClass:"modal-dialog modal-dialog-left modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Informazioni sulla pronuncia\n            ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itClose}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.documentInfo)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(("" + (_vm.documentInfo.type[0].toUpperCase()) + (_vm.documentInfo.type.slice(1)))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.documentInfo.number)+"/"+_vm._s(_vm.documentInfo.year))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Ecli")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.documentInfo.ecli))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Giudizio")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.documentInfo.giudizio))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Presidente")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.documentInfo.presidente))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Relatore")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.documentInfo.relatore))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Data Decisione")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.documentInfo.decisioneDate))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Data Deposito")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.documentInfo.depositoDate))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Riferimenti Alle Pronunce Della Corte Costituzionale")]),_vm._v(" "),_c('td',[(_vm.aknString)?_c('ChartGiurisprudenza',{attrs:{"aknString":_vm.aknString}}):_vm._e()],1)]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Riferimenti Alla Legislazione")]),_vm._v(" "),_c('td',[(_vm.aknString)?_c('ChartLegislazione',{attrs:{"aknString":_vm.aknString}}):_vm._e()],1)])])])])]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-lg-12 py-lg-12"},[_c('h6',[_vm._v("\n                Dammi qualche secondo, sto scaricando le informazioni sulla pronuncia!\n              ")]),_vm._v(" "),_c('Spinner')],1)])]),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Chiudi")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"document-viewer","role":"document"}},[(_vm.aknString)?_c('HeaderDocument',{attrs:{"docUri":_vm.docUri,"year":this.$route.params.year,"number":this.$route.params.number}}):_vm._e(),_vm._v(" "),(_vm.aknString)?_c('ModalDocumentInfo',{ref:"modalInfo",attrs:{"aknString":_vm.aknString,"year":this.$route.params.year,"number":this.$route.params.number}}):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container px-4 my-4"},[(_vm.aknString)?_c('div',{staticClass:"row"},[_c('b-container',{staticClass:"main-container",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"index-col d-none d-md-block affix-parent",attrs:{"cols":"3"}},[_c('div',{ref:"aknIndex",staticClass:"sidebar-wrapper it-line-right-side affix-top"},[_c('div',{staticClass:"sidebar-linklist-wrapper"},[_c('h3',[_vm._v("Indice Dei Contenuti")]),_vm._v(" "),_c('div',{staticClass:"link-list-wrapper"},[_c('ul',{staticClass:"link-list"},_vm._l((_vm.aknIndex),function(item){return _c('li',{key:item.name},[(item.hierarchies)?_c('a',{staticClass:"list-item large medium right-icon",attrs:{"href":"#collapseArticolato","data-toggle":"collapse","aria-expanded":"false","aria-controls":"collapseArticolato"}},[_c('span',[_vm._v(_vm._s(item.localeLabel))]),_vm._v(" "),_c('svg',{staticClass:"icon icon-sm icon-primary right",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.icons.itExpand}})])]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"link-sublist collapse show",attrs:{"id":"collapseArticolato"}},_vm._l((item.hierarchies),function(hier){return _c('li',{key:hier.xpath},[(hier.level === 1)?_c('a',{staticClass:"list-item",attrs:{"href":hier.eId,"data-attribute":"forward"},on:{"click":function($event){$event.preventDefault();return _vm.goToPartition(hier)}}},[_c('span',[_vm._v(_vm._s(hier.localeLabel))])]):_vm._e()])}),0),_vm._v(" "),(!item.hierarchies)?_c('a',{staticClass:"list-item large medium right-icon",attrs:{"href":item.eId,"data-attribute":"forward"},on:{"click":function($event){$event.preventDefault();return _vm.goToPartition(item)}}},[_vm._v("\n                        >\n                        "),_c('span',{},[_vm._v(_vm._s(item.localeLabel))])]):_vm._e()])}),0)])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"9","md":"10"}},[_c('div',{staticClass:"container document-section"},[(_vm.aknString)?_c('AknVisualizer',{ref:"aknVisualizer",attrs:{"akn-string":_vm.getAknString,"theme":'designItalia'}}):_vm._e()],1)])],1)],1)],1):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-lg-12 py-lg-12"},[_c('h6',[_vm._v("\n          Dammi qualche secondo, sto scaricando il tuo documento!\n        ")]),_vm._v(" "),_c('Spinner')],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsList_vue__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6723396_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsList_vue__ = __webpack_require__(872);
function injectStyle (ssrContext) {
  __webpack_require__(867)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e6723396"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6723396_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 867:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 869:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48f7d728_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__ = __webpack_require__(871);
function injectStyle (ssrContext) {
  __webpack_require__(870)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48f7d728_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 870:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 871:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col col-lg-12 px-lg-12 py-lg-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-lg-12 py-lg-12"},[_c('h6',[_vm._v("Stai applicando questi filtri:")]),_vm._v(" "),(_vm.pronunceFilters.years && _vm.pronunceFilters.years.length)?_c('div',{staticClass:"container years-filter-containers"},_vm._l((_vm.pronunceFilters.years),function(year,$index){return _c('div',{key:("y" + $index),staticClass:"chip anno-bg"},[_c('span',{staticClass:"chip-label text-white"},[_c('em',[_vm._v("anno")]),_vm._v(": "+_vm._s(year))]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.deleteFilter('years', _vm.$indexY)}}},[_c('svg',{staticClass:"icon white"},[_c('use',{attrs:{"xlink:href":_vm.icons.itClose}})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Elimina filtro")])])])}),0):_vm._e(),_vm._v(" "),_vm._l((_vm.pronunceFilters.presidents),function(presidente,$index){return _c('div',{key:("p" + $index),staticClass:"chip presidente-bg"},[_c('span',{staticClass:"chip-label text-white"},[_c('em',[_vm._v("presidente")]),_vm._v(": "+_vm._s(presidente))]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.deleteFilter('presidents', $index)}}},[_c('svg',{staticClass:"icon white"},[_c('use',{attrs:{"xlink:href":_vm.icons.itClose}})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Elimina filtro")])])])}),_vm._v(" "),_vm._l((_vm.pronunceFilters.relators),function(relatore,$index){return _c('div',{key:("r" + $index),staticClass:"chip relatore-bg"},[_c('span',{staticClass:"chip-label text-white"},[_c('em',[_vm._v("relatore")]),_vm._v(": "+_vm._s(relatore))]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.deleteFilter('relators', $index)}}},[_c('svg',{staticClass:"icon white"},[_c('use',{attrs:{"xlink:href":_vm.icons.itClose}})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Elimina filtro")])])])}),_vm._v(" "),_vm._l((_vm.pronunceFilters.judges),function(giudice,$index){return _c('div',{key:("j" + $index),staticClass:"chip giudice-bg"},[_c('span',{staticClass:"chip-label text-white"},[_c('em',[_vm._v("giudice")]),_vm._v(": "+_vm._s(giudice))]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.deleteFilter('judges', $index)}}},[_c('svg',{staticClass:"icon white"},[_c('use',{attrs:{"xlink:href":_vm.icons.itClose}})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Elimina filtro")])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn btn-outline-primary btn-lg my-4 float-right btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteAllFilters()}}},[_vm._v("Cancella tutti i filtri")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 872:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container px-4 my-4",attrs:{"id":"in-evidenza"}},[_c('h3',{staticClass:"mb-4 text-primary"},[_vm._v("Pronunce")]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.filtersSet())?_c('div',[_c('Filters')],1):_vm._e()]),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs auto",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"id":"tab-sentenze-tab","data-toggle":"tab","href":"#tab-sentenze","role":"tab","aria-controls":"tab-sentenze","aria-selected":"true"}},[_vm._v("\n        Sentenze\n        "),_c('span',{staticClass:"badge sentenze-bg badge-total-pronunce"},[_vm._v(_vm._s(_vm.documentsList.totalSentenze))])])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"tab-ordinanze-tab","data-toggle":"tab","href":"#tab-ordinanze","role":"tab","aria-controls":"tab-ordinanze","aria-selected":"false"}},[_vm._v("\n        Ordinanze\n        "),_c('span',{staticClass:"badge ordinanze-bg badge-total-pronunce"},[_vm._v(_vm._s(_vm.documentsList.totalOrdinanze))])])])]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane p-4 fade show active",attrs:{"id":"tab-sentenze","role":"tabpanel","aria-labelledby":"tab-sentenze-tab"}},[_c('table',{staticClass:"table table-striped"},[_vm._m(0),_vm._v(" "),(_vm.noResults.sentenze)?_c('tbody',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.documentsList.sentenze.length >= 1)?_c('tbody',[_vm._l((_vm.documentsList.sentenze),function(pronuncia,$index){return _c('tr',{key:$index,attrs:{"set":_vm.p=pronuncia.pronunciaInfo}},[_c('th',{attrs:{"scope":"row"}},[_c('router-link',{staticClass:"spacing nav-link",attrs:{"to":{
                  path: ("pronuncia/sentenza/" + (_vm.p.year) + "/" + (_vm.p.number)),
                  // query: {docUri: p.docUri},
                }}},[_vm._v("\n              "+_vm._s(_vm.p.number)+"/"+_vm._s(_vm.p.year)+"\n              ")])],1),_vm._v(" "),_c('td',{staticClass:"d-none d-sm-table-cell"},[_c('strong',{staticClass:"sentenze-text"},[_vm._v("\n                "+_vm._s(_vm.p.ecli)+"\n              ")])]),_vm._v(" "),_c('td',{staticClass:"d-none d-sm-table-cell"},[_vm._v(_vm._s(_vm.p.presidente))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.p.relatore))]),_vm._v(" "),_c('td',{staticClass:"d-none d-sm-table-cell"},[_c('router-link',{staticClass:"btn btn-xs",attrs:{"role":"button","to":{
                  path: ("pronuncia/sentenza/" + (_vm.p.year) + "/" + (_vm.p.number)),
                  // query: {docUri: p.docUri},
                }}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itPasswordVisible}})])]),_vm._v(" "),_c('a',{staticClass:"btn btn-xs",attrs:{"role":"button","aria-label":"Download Akoma Ntoso","href":_vm.getDownloadUrl(_vm.p.docUri, _vm.p.year, _vm.p.number),"target":"_blank"}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itDownload}})])])],1)])}),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row","colspan":"5"}},[_c('infinite-loading',{attrs:{"distance":1000},on:{"infinite":_vm.infiniteHandlerSentenze}})],1)])],2):_c('tbody',[(!_vm.noResults.sentenze)?_c('tr',[_c('th',{attrs:{"scope":"row","colspan":"5"}},[_c('Spinner')],1)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-4 fade",attrs:{"id":"tab-ordinanze","role":"tabpanel","aria-labelledby":"tab-ordinanze-tab"}},[_c('table',{staticClass:"table table-striped"},[_vm._m(2),_vm._v(" "),(_vm.noResults.ordinanze)?_c('tbody',[_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.documentsList.ordinanze.length >= 1)?_c('tbody',[_vm._l((_vm.documentsList.ordinanze),function(pronuncia,$index){return _c('tr',{key:$index,attrs:{"set":_vm.p=pronuncia.pronunciaInfo}},[_c('th',{attrs:{"scope":"row"}},[_c('router-link',{staticClass:"spacing nav-link",attrs:{"to":{
                  path: ("pronuncia/ordinanza/" + (_vm.p.year) + "/" + (_vm.p.number)),
                  // query: {docUri: p.docUri},
                }}},[_vm._v("\n              "+_vm._s(_vm.p.number)+"/"+_vm._s(_vm.p.year)+"\n              ")])],1),_vm._v(" "),_c('td',{staticClass:"d-none d-sm-table-cell"},[_c('strong',{staticClass:"ordinanze-text"},[_vm._v("\n                "+_vm._s(_vm.p.ecli)+"\n              ")])]),_vm._v(" "),_c('td',{staticClass:"d-none d-sm-table-cell"},[_vm._v(_vm._s(_vm.p.presidente))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.p.relatore))]),_vm._v(" "),_c('td',{staticClass:"d-none d-sm-table-cell"},[_c('router-link',{staticClass:"btn",attrs:{"role":"button btn-xs","to":{
                  path: ("pronuncia/ordinanza/" + (_vm.p.year) + "/" + (_vm.p.number)),
                  // query: {docUri: p.docUri},
                }}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itPasswordVisible}})])]),_vm._v(" "),_c('a',{staticClass:"btn btn-xs",attrs:{"role":"button","aria-label":"Download Akoma Ntoso","href":_vm.getDownloadUrl(_vm.p.docUri, _vm.p.year, _vm.p.number),"target":"_blank"}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.icons.itDownload}})])])],1)])}),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row","colspan":"5"}},[_c('infinite-loading',{attrs:{"distance":1000},on:{"infinite":_vm.infiniteHandlerOrdinanze}})],1)])],2):_c('tbody',[(!_vm.noResults.ordinanze)?_c('tr',[_c('th',{attrs:{"scope":"row","colspan":"5"}},[_c('Spinner')],1)]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col","sortable":""}},[_vm._v("Numero/Anno")]),_vm._v(" "),_c('th',{staticClass:"d-none d-sm-table-cell",attrs:{"scope":"col"}},[_vm._v("ECLI")]),_vm._v(" "),_c('th',{staticClass:"d-none d-sm-table-cell",attrs:{"scope":"col"}},[_vm._v("Presidente")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Relatore")]),_vm._v(" "),_c('th',{staticClass:"d-none d-sm-table-cell",attrs:{"scope":"col"}},[_vm._v("Azioni")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"row","colspan":"5"}},[_c('h6',[_vm._v("Nessun Risultato per la tua ricerca! "),_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#modalsearch"}},[_vm._v(" Prova a corregerla!")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Numero/Anno")]),_vm._v(" "),_c('th',{staticClass:"d-none d-sm-table-cell",attrs:{"scope":"col"}},[_vm._v("ECLI")]),_vm._v(" "),_c('th',{staticClass:"d-none d-sm-table-cell",attrs:{"scope":"col"}},[_vm._v("Presidente")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Relatore")]),_vm._v(" "),_c('th',{staticClass:"d-none d-sm-table-cell",attrs:{"scope":"col"}},[_vm._v("Azioni")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"row","colspan":"5"}},[_c('h6',[_vm._v("Nessun Risultato per la tua ricerca! "),_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#modalsearch"}},[_vm._v(" Prova a corregerla!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"document"}},[_vm._m(0),_vm._v(" "),_c('DocumentsList',{ref:"documentsListComponent"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container px-4 my-4",attrs:{"id":"intro"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-lg-12 py-lg-12"},[_c('h1',[_vm._v("Pronunce della Corte Costituzionale")]),_vm._v(" "),_c('p',[_vm._v("\n          In questa pagina puoi consultare tutte le pronunce della Corte Costituzionale navigando la tabella qui sotto.\n          Ricordati che puoi fare una ricerca mirata "),_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#modalsearch"}},[_vm._v(" cliccando qui")]),_vm._v(" oppure sul pulsante di ricerca in alto a destra.\n        ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 874:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pronuncia_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1a1c71_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pronuncia_vue__ = __webpack_require__(876);
function injectStyle (ssrContext) {
  __webpack_require__(875)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d1a1c71"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pronuncia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1a1c71_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pronuncia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 875:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Document',{attrs:{"docUri":_vm.query.docUri}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Informazioni_vue__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b00c206_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Informazioni_vue__ = __webpack_require__(879);
function injectStyle (ssrContext) {
  __webpack_require__(878)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b00c206"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Informazioni_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b00c206_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Informazioni_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 878:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 879:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"document"}},[_c('section',{staticClass:"container px-4 my-4",attrs:{"id":"info"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-lg-12 py-lg-12"},[_c('h1',[_vm._v("Informazioni")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_vm._v("\n        Successivamente il\n          "),_c('router-link',{attrs:{"to":"/gruppo-di-lavoro"}},[_vm._v("gruppo di lavoro")]),_vm._v("\n            ha proseguito la ricerca raffinando i prototipi,\n            aggiungendo funzionalità (e.g., NER) e implementando un'interfaccia grafica in linea con le linee guida\n            "),_c('a',{attrs:{"target":"_blank","href":"https://designers.italia.it/guide/"}},[_vm._v("AgID per lo sviluppo dei siti web delle pubbliche amministrazioni. ")])],1),_vm._v(" "),_c('p',[_vm._v("\n          Il progetto è in continua evoluzione allo scopo di raffinare maggiormente l'accuratezza del markup XML-AKN della struttura dei documenti, dei riferimenti normativi, dei riferimenti giurisprudenziali, delle parti semantiche del discorso (e.g., motivazioni). Si intende utilizzare tecniche di legal analytics e di network analysis per agevolare la comprensione dei fenomeni giuridici a beneficio di tutti gli attori coinvolti (e.g., operatori del diritto, corte, cittadini, etc.).\n        ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          Questo sito è stato realizzato nell'ambito di un progetto di ricerca del\n          "),_c('a',{attrs:{"target":"_blank","href":"http://www.cirsfid.unibo.it"}},[_vm._v("CIRSFID-Università di Bologna")]),_vm._v(",\n          parzialmente finanziato dal\n          "),_c('a',{attrs:{"target":"_blank","href":"https://cached.forges.forumpa.it/assets/Speeches/24096/06_co57_palmirani_monica.pdf"}},[_vm._v("\n            progetto della Presidenza del Consiglio denominato LexDatafication")]),_vm._v(".\n          LexDatafication prevedeva la realizzazione di prototipi per dimostrare la fattibilità della conversione delle decisioni della Corte Costituzionale\n          nel formato\n          "),_c('a',{attrs:{"target":"_blank","href":"http://docs.oasis-open.org/legaldocml/akn-core/v1.0/akn-core-v1.0-part1-vocabulary.html"}},[_vm._v("XML Akoma Ntoso")]),_vm._v(".\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          I materiali XML-AKN qui disponibili sono rilasciati con\n          "),_c('a',{attrs:{"target":"_blank","href":"https://creativecommons.org/licenses/by/4.0/deed.it"}},[_vm._v("licenza CC-BY-4.0")]),_vm._v("\n          con preghiera di citare la fonte in questo modo nei metadati:\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('code',[_c('pre',[_vm._v("            <http://newDataset>\n                a dcatapit:Dataset, dcat:Dataset;\n                prov:wasDerivedFrom <https://gitlab.com/CIRSFID/cortecostituzionale-py/tree/master/data/out/valid>.\n\n            <https://gitlab.com/CIRSFID/cortecostituzionale-py/tree/master/data/out/valid>\n                a dcatapit:Dataset, dcat:Dataset;\n                dct:rightsHolder <https://www.indicepa.gov.it/ricerca/n-dettaglioaoo.php?cod_amm=uni_bo&cod_aoo=CIRSFID>.\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GruppoDiLavoro_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1755092_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GruppoDiLavoro_vue__ = __webpack_require__(882);
function injectStyle (ssrContext) {
  __webpack_require__(881)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1755092"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GruppoDiLavoro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1755092_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GruppoDiLavoro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 881:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 882:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main","role":"document"}},[_c('section',{staticClass:"container px-4 my-4",attrs:{"id":"info"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-lg-12 py-lg-12"},[_c('h1',[_vm._v("Gruppo di lavoro")]),_vm._v(" "),_c('h5',{staticClass:"my-4"},[_vm._v("\n          Questo sito è stato realizzato dal gruppo di lavoro coordinato dalla\n          "),_c('a',{attrs:{"target":"_blank","href":"https://www.unibo.it/sitoweb/monica.palmirani"}},[_vm._v("prof.ssa Monica Palmirani")]),_vm._v(" e così composto:\n        ")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-start justify-content-md-around flex-wrap flex-sm-nowrap my-5"},[_c('div',{staticClass:"avatar-wrapper avatar-extra-text"},[_c('div',{staticClass:"avatar size-xl"},[_c('img',{attrs:{"src":"static/team/monica.png","alt":"Monica Palmirani"}})]),_vm._v(" "),_c('div',{staticClass:"extra-text"},[_c('h4',[_c('a',{attrs:{"target":"_blank","href":"https://www.unibo.it/sitoweb/monica.palmirani"}},[_vm._v("Monica Palmirani")])]),_vm._v(" "),_c('p',[_vm._v("Professoressa Ordinaria in Informatica Giuridca")])])]),_vm._v(" "),_c('div',{staticClass:"avatar-wrapper avatar-extra-text"},[_c('div',{staticClass:"avatar size-xl"},[_c('img',{attrs:{"src":"static/team/luca.jpg","alt":"Luca Cervone"}})]),_vm._v(" "),_c('div',{staticClass:"extra-text"},[_c('h4',[_c('a',{attrs:{"target":"_blank","href":"https://www.unibo.it/sitoweb/luca.cervone"}},[_vm._v("Luca Cervone")])]),_vm._v(" "),_c('p',[_vm._v("Dottore di Ricerca in Informatica Giuridica")])])]),_vm._v(" "),_c('div',{staticClass:"avatar-wrapper avatar-extra-text"},[_c('div',{staticClass:"avatar size-xl"},[_c('img',{attrs:{"src":"static/team/octavian.jpeg","alt":"Octavian Bujor"}})]),_vm._v(" "),_c('div',{staticClass:"extra-text"},[_c('h4',[_c('a',{attrs:{"target":"_blank","href":"https://www.linkedin.com/in/octavian-bujor-6b436790/"}},[_vm._v("Octavian Bujor")])]),_vm._v(" "),_c('p',[_vm._v("Analista Programmatore Senior")])])]),_vm._v(" "),_c('div',{staticClass:"avatar-wrapper avatar-extra-text"},[_c('div',{staticClass:"avatar size-xl"},[_c('img',{attrs:{"src":"static/team/biagio.jpeg","alt":"Biagio Distefano"}})]),_vm._v(" "),_c('div',{staticClass:"extra-text"},[_c('h4',[_c('a',{attrs:{"target":"_blank","href":"https://www.linkedin.com/in/bdles/?originalSubdomain=it"}},[_vm._v("Biagio Distefano")])]),_vm._v(" "),_c('p',[_vm._v("Dottorando in Informatica Giuridica")])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex flow-row align-content-stretch flex-wrap flex-sm-nowrap"},[_c('div',{staticClass:"avatar-wrapper avatar-extra-text"},[_c('div',{staticClass:"avatar size-xl"},[_c('img',{attrs:{"src":"static/team/francescod.jpeg","alt":"Francesco Draicchio"}})]),_vm._v(" "),_c('div',{staticClass:"extra-text"},[_c('h4',[_c('a',{attrs:{"target":"_blank","href":"https://www.linkedin.com/in/francescodraicchio/?originalSubdomain=it"}},[_vm._v("Francesco Draicchio")])]),_vm._v(" "),_c('p',[_vm._v("Analista Programmatore Senior")])])]),_vm._v(" "),_c('div',{staticClass:"avatar-wrapper avatar-extra-text mx-md-3 mx-lg-3 mx-xs-0 mx-sm-0"},[_c('div',{staticClass:"avatar size-xl"},[_c('img',{attrs:{"src":"static/team/francescos.png","alt":"Francesco Sovrano"}})]),_vm._v(" "),_c('div',{staticClass:"extra-text"},[_c('h4',[_c('a',{attrs:{"target":"_blank","href":"https://www.unibo.it/sitoweb/francesco.sovrano2"}},[_vm._v("Francesco Sovrano")])]),_vm._v(" "),_c('p',[_vm._v("Dottorando in Informatica")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 883:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuidaAllUso_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e0a404_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuidaAllUso_vue__ = __webpack_require__(885);
function injectStyle (ssrContext) {
  __webpack_require__(884)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02e0a404"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuidaAllUso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e0a404_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuidaAllUso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 884:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main","role":"document"}},[_c('section',{staticClass:"container px-4 my-4",attrs:{"id":"info"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-lg-12 py-lg-12"},[_c('h1',[_vm._v("Metodologia")]),_vm._v(" "),_c('p',[_vm._v("\n          Il presente progetto permette di navigare le sentenze e le ordinanze della Corte Costituzionale utilizzando i benefici offerti dallo standard internazionale XML-AKN\n          come poter navigare i riferimenti giurisrpudenziali. Il processo prevede il riuso dei contenuti (testi) e dei metadati dal "),_c('a',{attrs:{"target":"_blank","href":" https://dati.cortecostituzionale.it/"}},[_vm._v("portale ufficiale della Corte Costituzionale")]),_vm._v(".\n          I materiali open data sono stati elaborati con algoritmi di NLP (natural language processing) sviluppati dal CIRSFID-UNIBO per qualificare alcune parti rilevanti del discorso giuridico (e.g., riferimenti normativi) e per strutturare il documento in modo omogeneo secondo lo standard XML-AKN  (introduzione, fatto, diritto, motivazione). Questa strutturazione machine-readable facilita l'interoperabilità,\n          il riuso e la ricercabilità all'interno della collezione dei documenti di concetti giuridici. Molta attenzione è stata riservata a preservare l'autorevolezza della fonte informativa,\n          la quale viene annota in modo da non alterare il contenuto originale. Si vuole valorizzare l'uso di standard comunitari quali "),_c('a',{attrs:{"target":"_blank","href":"https://dati.cortecostituzionale.it/ECLI/ECLI"}},[_vm._v("ECLI")]),_vm._v(". In questo modo contenuto, URI, metadati si rappresentano in un unico formato, XML-AKN, per agevolare il riutilizzo e le interconnessioni anche con altre collezioni documentali quali Normattiva.\n        ")]),_vm._v(" "),_c('h1',[_vm._v("Bulk")]),_vm._v(" "),_c('p',[_vm._v("\n          La collezione documentale XML-AKN è disponibile "),_c('a',{attrs:{"target":"_blank","href":"https://gitlab.com/CIRSFID/cortecostituzionale-py/tree/master/data/out"}},[_vm._v("mediante bulk")]),_vm._v(".\n        ")]),_vm._v(" "),_c('h1',[_vm._v("Ricerche")]),_vm._v(" "),_c('p',[_vm._v("\n          I materiali possono essere ricercati secondo diversi canali utilizzando direttamente la marcatura XML. Sarà quindi facile aggiungere in futuro nuovi campi di ricerca. Accedendo mediante l'icona della lente si possono per ora, ma solo a titolo esemplificativo, filtrare i documenti secondo questi canali:\n        ")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("arco temporale;")]),_vm._v(" "),_c('li',[_vm._v("presidente;")]),_vm._v(" "),_c('li',[_vm._v("relatore.")])]),_vm._v(" "),_c('p',[_vm._v("\n          Per esempio nella immagine seguente si vuole selezionare tutte le pronunce dal 2001 al 2019, con un determinato presiende e un determinato relatore.\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center my-5"},[_c('img',{staticClass:"rounded w-75",attrs:{"src":"static/manual/ricerca.png","alt":"esempio ricerca"}})]),_vm._v(" "),_c('p',[_vm._v("\n          La visualizzazione della ricerca presenta i criteri di selezione (box in alto colorato) i quali possono essere facilmente elimiati individualmente cliccando sulla \"x\":\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center my-5"},[_c('img',{staticClass:"rounded w-75",attrs:{"src":"static/manual/filtri.png","alt":"esempio filtri"}})]),_vm._v(" "),_c('h1',[_vm._v("Visualizzazioni")]),_vm._v(" "),_c('p',[_vm._v("\n        Per agevolare la lettura delle pronunce e la loro analisi si è corredato il testo di una visualizzazione particolare che mette in evidenza i metadati (e.g., ECLI, tipo di giudizio, etc.). Questi dati sono affidabili perchè presi dalle fonti autorevoli open data della Corte Costituzionale.\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center my-5"},[_c('img',{staticClass:"rounded w-75",attrs:{"src":"static/manual/info_pronuncia.png","alt":"esempio informazioni pronuncia"}})]),_vm._v(" "),_c('p',[_vm._v("\n          Abbiamo aggiunto anche una visualizzazione grafica dei riferimenti legislativi e giurisprudenziali presenti nella pronunica. In particolare quelli giurisprudenziali si possono navigare cliccando sul grafico stesso.\n          Questa sezione grafica è incompleta ed è presentata a mero scopo dimostrativo relativamente alle potenzialità del metodo basato sul formato standard XML-AKN. Per renderle affidabili tali informazioni occorrerebbe ottenere una validazione da esperti guridici, validazione che potrà essere utilizzata per addestrare il software NLP in modo da migliorare in modo automatico la precisione dell'annotazione.\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center my-5"},[_c('img',{staticClass:"rounded w-75",attrs:{"src":"static/manual/grafico.png","alt":"esempio visualizzazioni"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[434]);


// WEBPACK FOOTER //
// static/js/app.cadfe892698599740da4.js